<template>
    <div class="contentbox productedit">
      <div class="toptitle">
        <div class="return">
          <div @click="$router.go(-1)">&lt;</div>
        </div>
        <p>编辑产品</p>
        <div>
          <!--<span @click="inorderlist">-->
            <!--<img src="../assets/images/chat.png" alt="">-->
          <!--</span>-->
          <!--<span class="personalicon">-->
            <!--单号-->
          <!--</span>-->
        </div>
      </div>
      <mt-popup
        v-model="popupVisible"
        :modal="false"
        position="right">
        <slot>
          <div class="PersonalCenter">
            <h1>个人中心</h1>
            <div>公司名称({{$store.state.loginuserdata.enterprise}})</div>
            <div>用户名称({{$store.state.loginuserdata.username}})</div>
            <div><mt-button @click="curtainlogout" type="danger">退出</mt-button></div>
            <div><mt-button @click="showPersonalCenter" type="primary">返回</mt-button></div>
          </div>
        </slot>
      </mt-popup>
      <!--主产品-->
      <div class="pcbox">
        <div class="r">
          <div class="numberbox">
            <div class="title" v-html="detail.product_name"></div>
            <div class="clearfloat number">
              <!--<p class="lf">-->
                <!--<span @click="productreduce" class="reduce">-</span>-->
                <!--<span class="num">{{num}}</span>-->
                <!--<span @click="productadd" class="add">+</span>-->
              <!--</p>-->
              <p v-if="detail.expend_price>0" class="rg">
                <!--{{detail.currency_symbol}} {{detail.expend_price}}-->
              </p>
              <!--<p v-if="detail.expend_price<=0 && productAccessories.length>=2" class="rg">{{detail.currency_symbol}}-->
                <!--{{minAccessories}} ~ {{detail.currency_symbol}} {{mixAccessories}}</p>-->
              <!--<p v-if="detail.expend_price<=0 && productAccessories.length<2" class="rg">{{detail.currency_symbol}}-->
                <!--{{mixAccessories}}</p>-->
            </div>
            <!--<div class="clearfloat">-->
            <!--安裝費用：-->
            <!--<span> {{detail.product_installation_charge_curr}}-->
            <!--{{detail.product_installation_charge}}</span>-->
            <!--</div>-->
            <!--属性-->
            <div v-if="typeof productAttribute === 'object'"
                 :key="index"
                 v-for="(itme,index) in productAttribute">
              <span class="attributename">{{itme.product_attribute_name_title}}：</span>
              <el-input style="width: 20%"
                        size="mini"
                        placeholder="input"
                        @blur="onSizerange"
                        @input="oninput"
                        v-if="!itme.attribute_list"
                        :data-min="itme.restriction_min"
                        :data-max="itme.restriction_max"
                        :data-attribute_id="itme.attribute_id"
                        v-model="itme.product_attribute_name"></el-input>
              <!--multiple  :multiple="itme.select_type==='2'" 多选-->
              <el-select @change="itme.select_type!=='2' && oninput()"
                         :multiple="itme.select_type==='2'"
                         :disabled="itme.disabled"
                         placeholder="Select"
                         v-model="itme.product_attribute_name"
                         v-if="itme.attribute_list && itme.product_attribute_name_title!='顏色'">
                <el-option
                  v-if="!itme.semicolon_arr"
                  v-for="(list) in itme.attribute_list"
                  :key="list"
                  :label="list"
                  :value="list">
                </el-option>
                <el-option
                  v-if="itme.semicolon_arr"
                  v-for="(list) in itme.semicolon_arr"
                  :key="list.value"
                  :label="list.name"
                  :value="list.value">
                </el-option>
              </el-select>

              <el-select v-if="itme.attribute_list && itme.product_attribute_name_title=='顏色'"
                         :style="{'background': itme.product_attribute_name}"
                         class="popper-class colorclass"
                         :disabled="itme.disabled"
                         size="mini"
                         v-model="itme.product_attribute_name" placeholder="Select">
                <el-option
                  class="selectitme"
                  :style="{'background-color': list}"
                  v-for="(list) in itme.attribute_list"
                  :key="list"
                  :value="list">
                </el-option>
              </el-select>
            </div>
          </div>
          <!--计算属性 暂时隐藏-->
          <!--<div v-if="typeof productAttribute === 'object'" class="computedbox">-->
          <!--<div @click="showcomputedbox" class="clickbox">公式：</div>-->
          <!--<div :key="index"-->
          <!--v-if="itme.in_formula===1"-->
          <!--v-for="(itme,index) in productAttribute">-->
          <!--<span class="attributename">{{itme.product_attribute_name_title}}：</span>-->
          <!--<el-input v-if="!itme.attribute_list"-->
          <!--size="mini"-->
          <!--placeholder="input"-->
          <!--type="number"-->
          <!--@blur="onSizerange"-->
          <!--@input="oninput"-->
          <!--:data-min="itme.restriction_min"-->
          <!--:data-max="itme.restriction_max"-->
          <!--:data-attribute_id="itme.attribute_id"-->
          <!--v-model="itme.product_attribute_name"></el-input>-->
          <!--&lt;!&ndash;<select @change="oninput" v-if="itme.attribute_list" v-model="itme.product_attribute_name">&ndash;&gt;-->
          <!--&lt;!&ndash;<option :key="index2" v-for="(list,index2) in itme.attribute_list">{{list}}</option>&ndash;&gt;-->
          <!--&lt;!&ndash;</select>&ndash;&gt;-->
          <!--<el-select @change="oninput"-->
          <!--placeholder="Select"-->
          <!--v-model="itme.product_attribute_name"-->
          <!--v-if="itme.attribute_list">-->
          <!--<el-option-->
          <!--v-if="!itme.semicolon_arr"-->
          <!--v-for="(list) in itme.attribute_list"-->
          <!--:key="list"-->
          <!--:label="list"-->
          <!--:value="list">-->
          <!--</el-option>-->
          <!--<el-option-->
          <!--v-if="itme.semicolon_arr"-->
          <!--v-for="(list) in itme.semicolon_arr"-->
          <!--:key="list.value"-->
          <!--:label="list.name"-->
          <!--:value="list.value">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div><span class="formula">公式：</span><span v-html="productCalculationFormula"></span></div>-->
          <!--<div v-if="multiplesFormula"><span class="formula">倍数公式：</span><span v-html="multiplesFormula"></span></div>-->
          <!--<div>結果：{{detail.result}}</div>-->
          <!--</div>-->
        </div>
        <div class="topimgbox">
          <!--<img :src="detail.smallpic" alt="">-->
          <img src="../assets/images/style.png" ref="p_img" alt="">
          <img src="../assets/images/style.png" ref="original_graph_img" alt="">
          <div class="canvasBox" ref="canvasHW">
            <canvas @touchstart='touchStart'
                    @touchmove='touchMove'
                    @touchend='touchEnd'
                    ref="canvasF"
                    @click="click_canvas"
                    @mousedown="mouseDown"
                    @mousemove="mouseMove"
                    @mouseup="mouseUp"></canvas>
            <div class="btnBox">
              <mt-button size="small" type="primary" @click="painting">Drawing</mt-button>
              <mt-button v-show="this.editing_status !== 'input_text'" size="small" type="primary" @click="input_text">
                Instruction
              </mt-button>
              <mt-button v-show="this.editing_status === 'input_text'" size="small" type="primary" @click="input_text_en">
                Finish
              </mt-button>
              <!--<mt-button size="small" type="primary" @click="commit">提交签名</mt-button>-->
              <!--<mt-button type="primary" size="small" @click="overwrite">Delete</mt-button>-->
            </div>
            <textarea v-show="this.editing_status === 'input_text'" ref="canvas_input" type="text"
                      v-model="canvas_text"></textarea>
          </div>
        </div>
      </div>
      <!--<div class="meassagebox">-->
        <!--商品描述：<span v-html="detail.product_description"></span>-->
      <!--</div>-->
      <div class="garnishbox"
           :key="i" v-for="(productAccessories_itme,i) in productAccessories"
           v-if="typeof productAccessories === 'object'">
        <!--一级配件-->
        <h1>{{productAccessories_itme.category_name}}</h1>
        <ul v-if="typeof productAccessories_itme.productAccessories === 'object'" class="clearfloat">
          <li :class="itme.select" :key="index"
              v-for="(itme,index) in productAccessories_itme.productAccessories">
            <div class="titlebox">
              <div class="t">
                <p class="tltle">
                  <span>{{itme.product_name}} </span>
                  <span v-if="itme.select!=='active' && itme.sun>0">
                  <i class="el-icon-check"></i>
                </span>
                </p>
                <!--<p v-if="itme.productAccessoriesPrice!==0">{{itme.currency_symbol}} {{itme.productAccessoriesPrice}}</p>  -->
              </div>

              <div class="img_box">
                <img @click.capture="onselect(itme.product_id)"
                     onerror="onerror=null;src='./static/img/buf.e019189.png'"
                     :src="itme.bigImageUrl?itme.bigImageUrl:buf"/>
              </div>
            </div>
            <!--属性组合-->
            <!--<div class="attributebox give" v-if="itme.AttributeGroup && itme.select==='active'">-->
              <!--組合屬性：-->
              <!--<el-select @change="onAccessoriesinput(itme.Identification)"-->
                         <!--v-model="itme.composite_attribute_value">-->
                <!--<el-option-->
                  <!--v-for="(list,index) in itme.AttributeGroup"-->
                  <!--:key="index"-->
                  <!--:label="list.attribute_value_group"-->
                  <!--:value="list.id">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</div>-->
            <!--属性-->
            <div class="attributebox"
                 v-if="typeof itme.productAttribute === 'object' && itme.select==='active'">
              <div>
                <p :key="list.product_attribute_id"
                   v-for="(list) in itme.productAttribute">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            placeholder="input"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme.Identification,list.attribute_id,Number(list.restriction_min),Number(list.restriction_max))"
                            @input="onAccessoriesinput(itme.Identification,list.attribute_id)"
                            size="mini"></el-input>
                  <el-select  @change="onAccessoriesinput(itme.Identification,list.attribute_id)"
                              :multiple="list.select_type==='2'"
                              :disabled="list.disabled"
                              placeholder="Select"
                              size="mini"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!='顏色'">
                    <el-option
                      v-if="!list.semicolon_arr"
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                    <el-option
                      v-if="list.semicolon_arr"
                      v-for="(listchild) in list.semicolon_arr"
                      :key="listchild.value"
                      :label="listchild.name"
                      :value="listchild.value">
                    </el-option>
                  </el-select>
                  <!--颜色-->
                  <el-select
                    v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                    :style="{'background': list.product_attribute_name}"
                    class="popper-class"
                    size="mini"
                    v-model="list.product_attribute_name" placeholder="Select">
                    <el-option
                      class="selectitme"
                      :style="{'background-color': listchild}"
                      v-for="(listchild,index3) in list.attribute_list"
                      :key="index3"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
              </div>
            </div>
            <!--样式图片-->
            <div class="type_box" v-if="itme.select==='active' && itme.product_quotation_style_type !== 0">
              <img v-if="itme.product_quotation_style_type === '1'" src="../assets/images/yangshi1.png" alt="">
              <img v-if="itme.product_quotation_style_type === '2'" src="../assets/images/yangshi2.png" alt="">
            </div>
            <!--计算属性-->
            <!--<div class="attributebox"-->
                 <!--v-if="typeof itme.productAttribute === 'object' && itme.select==='active'">-->
              <!--<div>-->
                <!--<p :key="list.attribute_id"-->
                   <!--v-if="list.in_formula===1"-->
                   <!--:class="indexone==0?'one':''"-->
                   <!--v-for="(list,indexone) in itme.productAttribute">-->
                  <!--{{list.product_attribute_name_title}}:-->
                  <!--<el-input v-if="!list.attribute_list"-->
                            <!--@input="onAccessoriesinput(itme.Identification,list.attribute_id)"-->
                            <!--@blur="onattributeSizerange(itme.Identification,list.attribute_id,Number(list.restriction_min),Number(list.restriction_max))"-->
                            <!--:data-min="itme.restriction_min"-->
                            <!--:data-max="itme.restriction_max"-->
                            <!--v-model="list.product_attribute_name"-->
                            <!--type="number"-->
                            <!--placeholder="input"-->
                            <!--size="mini"></el-input>-->
                  <!--<el-select  @change="onAccessoriesinput(itme.Identification,list.attribute_id)"-->
                              <!--placeholder="Select"-->
                              <!--v-model="list.product_attribute_name"-->
                              <!--v-if="list.attribute_list">-->
                    <!--<el-option-->
                      <!--v-if="!list.semicolon_arr"-->
                      <!--v-for="(listchild) in list.attribute_list"-->
                      <!--:key="listchild"-->
                      <!--:label="listchild"-->
                      <!--:value="listchild">-->
                    <!--</el-option>-->
                    <!--<el-option-->
                      <!--v-if="list.semicolon_arr"-->
                      <!--v-for="(listchild) in list.semicolon_arr"-->
                      <!--:key="listchild.value"-->
                      <!--:label="listchild.name"-->
                      <!--:value="listchild.value">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                <!--</p>-->
                <!--<p v-if="typeof itme.productAttribute === 'object'">-->
                  <!--<span class="formula">公式：</span>-->
                  <!--<span v-html="itme.productCalculationFormula"></span>-->
                <!--</p>-->
                <!--<p v-if="typeof itme.multiplesAttribute === 'object'">-->
                  <!--<span class="formula">倍数公式：</span>-->
                  <!--<span v-html="itme.multiplesFormula"></span>-->
                <!--</p>-->
                <!--<p class="towbottom" v-if="typeof itme.productAttribute === 'object'">-->
                  <!--<span>结果：{{itme.result}}</span>-->
                <!--</p>-->
              <!--</div>-->
            <!--</div>-->

            <!--数量选择-->
            <!--<p v-if="itme.select==='active'" class="sunbox">-->
              <!--<span @click="onreduce(itme.Identification)" class="reduce">-</span>-->
              <!--<span class="num">{{itme.sun}}</span>-->
              <!--<span @click="onadd(itme.Identification)" class="add">+</span>-->
            <!--</p>-->
          </li>
        </ul>
      </div>
      <div class="pcbox2">
        <div class="l">
          <!--<div class="totalbox">-->
            <!--<span>總價</span>-->
            <!--<span>$ {{total}}</span>-->
          <!--</div>-->
          <!--<div class="remarks">-->
            <!--<textarea v-model="detail.goods_remark" placeholder="備註："></textarea>-->
          <!--</div>-->
        </div>
        <div class="r">
          <div class="usermeassagebox">
            <!--<ul>-->
              <!--<li>-->
                <!--A：<input v-model="remarks[0]"/>-->
              <!--</li>-->
              <!--<li>-->
                <!--B：<input v-model="remarks[1]"/>-->
              <!--</li>-->
              <!--<li>-->
                <!--C：<input v-model="remarks[2]"/>-->
              <!--</li>-->
              <!--<li>-->
                <!--D：<input v-model="remarks[3]"/>-->
              <!--</li>-->
              <!--<li>-->
                <!--E：<input v-model="remarks[4]"/>-->
              <!--</li>-->
            <!--</ul>-->
            <div>
              <!--<img v-if="detail.product_quotation_style_type === '1'" src="../assets/images/yangshi1.png" alt="">-->
              <!--<img v-if="detail.product_quotation_style_type === '2'" src="../assets/images/yangshi2.png" alt="">-->
            </div>
          </div>
          <div @click="onmessagebox(1)" class="butbox buboxadd">Re add</div>
          <div @click="onmessagebox" class="butbox">SAVE</div>
        </div>
      </div>
    </div>
</template>

<script>
  import { MessageBox,Popup  } from 'mint-ui';
  import Dot from '../assembly/Dot/Dot';
  import buf from '../assets/images/buf.png'
  import ScrollPosition from '../assets/js/scroll-position'
  import {
    getProDetail,
    LocalShoppingCart,
    curtainlogout,
    productFormula,
    getProActionPrice,
    getProductAttributeGroupPrice,
  } from '../assets/js/api'
    export default {
        name: "productedit",
        data(){
          return{
            buf,
            popupVisible:false,
            detail:{},
            productAccessories:{},
            productAttribute:[],
            productCalculationAttribute:{},
            productCalculationFormula:'',
            multiplesFormula:'',
            num:1,
            userinfo:[],
            remarks:[],
            showsparts2:[],
            showspartsname2:'',

            showsparts3:[],
            showspartsname3:'',

            showsparts4:[],
            showspartsname4:'',

            showsparts5:[],
            showspartsname5:'',

            showsparts6:[],
            showspartsname6:'',

            combinationattributes:[],
            attribute_group_value:'',

            editing_status: 'painting',
            points: [],
            canvasTxt: null,
            startX: 0,
            startY: 0,
            moveY: 0,
            moveX: 0,
            endY: 0,
            endX: 0,
            isDown: false,
            Style_pictures: '',
            canvas_text: '',
            canvas_text_left: 0,
            canvas_text_top: 0,
            inputX: 0,
            inputY: 0,
            original_graph:''
          }
        },
        components:{
          MessageBox,
          Popup,
          Dot
        },
        mounted(){

          // 获取本地购物车
          let LocalShoppingCart = JSON.parse(sessionStorage.getItem('LocalShoppingCart'))[this.$route.query.index]

          getProDetail(LocalShoppingCart.expend_id).then((data)=>{
            this.detail = data.detail
            // this.detail
            // 回写本地购物车
            this.num = Number.parseInt(LocalShoppingCart.sum) //主产品数量
            this.remarks = LocalShoppingCart.remarks //ABCDE
            this.detail.goods_remark = LocalShoppingCart.goods_remark  //主产品备注

            this.productCalculationFormula = data.productCalculationFormula //计算公式
            this.multiplesFormula = data.multiplesFormula //倍数公式
            let html1 = document.createElement('p')
            html1.innerHTML = this.detail.product_description
            this.detail.product_description = html1.innerText

            if (typeof data.productAttribute === 'object') {
              for (let key in data.productAttribute) {
                // 回写产品属性值
                LocalShoppingCart.formula_handle.map((itme=>{
                  // 对有;分号的属性做处理，选择属性时不显示分号后面的计算值
                  if (data.productAttribute[key].attribute_list) {
                    let semicolon = false
                    data.productAttribute[key].attribute_list.map(list=>{
                      if (list.indexOf(';') > -1){
                        semicolon = true
                      }
                    })
                    if (semicolon) {
                      data.productAttribute[key].semicolon_arr = []
                      data.productAttribute[key].attribute_list.map(list=>{
                        data.productAttribute[key].semicolon_arr.push({
                          name:list.split(';')[0],
                          value:list,
                        })
                      })
                    }
                  }
                  if (data.productAttribute[key].product_attribute_name_title ===  itme.split(':')[0]) {
                    if (data.productAttribute[key].select_type === '2'){
                      data.productAttribute[key].product_attribute_name = itme.split(':')[1].split('，')
                    }
                    else {
                      data.productAttribute[key].product_attribute_name = itme.split(':')[1];
                    }
                  }
                }))
                this.productAttribute.push(data.productAttribute[key])
              }
            }

            this.productCalculationAttribute = data.productCalculationAttribute //产品计算属性
            this.productAccessories = data.productAccessories  // 产品配件含子配件
            this.detail.selectCalculationAttributeIdStr =  this.productCalculationAttribute

            if (typeof this.productAccessories === 'object'){
              //初始化配件
              this.productAccessories.map((productAccessories_itme)=>{
                if (typeof productAccessories_itme.productAccessories === 'object') {
                  productAccessories_itme.productAccessories.map(itme=>{
                    itme.sun = 0    //数量
                    itme.result = 0 //计算价格
                    itme.Identification = this.guid() //配件的唯一标识时间戳加随机数
                    // 回写配件数量
                    if (LocalShoppingCart.partsData){
                      LocalShoppingCart.partsData.map((partsitme=>{
                        if (!partsitme.product_id) {
                          partsitme.product_id = partsitme.goods_parts_id
                        }
                        if (itme.product_id === partsitme.product_id){
                          itme.sun = Number.parseInt(partsitme.totalquantity)
                          //回写组合属性的价格
                          if (partsitme.attribute_group_price) {
                            itme.productAccessoriesPrice = partsitme.attribute_group_price
                          }
                          //回写组合属性id
                          if (partsitme.attribute_group_id) {
                            itme.composite_attribute_value = partsitme.attribute_group_id
                          }
                        }
                      }))
                    }
                    if (!itme.productAccessoriesPrice) {
                      itme.productAccessoriesPrice = 0
                    }
                    if (typeof itme.productAttribute === 'object'){
                      itme.productAttribute.map((list)=>{
                        // 对有;分号的属性做处理，选择属性时不显示分号后面的计算值
                        if (list.attribute_list) {
                          let semicolon = false
                          list.attribute_list.map(list=>{
                            if (list.indexOf(';') > -1){
                              semicolon = true
                            }
                          })
                          if (semicolon) {
                            list.semicolon_arr = []
                            list.attribute_list.map(list2=>{
                              list.semicolon_arr.push({
                                name:list2.split(';')[0],
                                value:list2,
                              })
                            })
                          }
                        }
                        // 回写配件属性
                        if (LocalShoppingCart.partsData){
                          LocalShoppingCart.partsData.map((partsitme=>{
                            if (itme.product_id === partsitme.product_id){
                              if (partsitme.formula_handle){
                                partsitme.formula_handle.map(formula_handleitme=>{
                                  if (list.product_attribute_name_title === formula_handleitme.split(':')[0]){
                                    if (list.select_type === '2'){
                                      list.product_attribute_name = formula_handleitme.split(':')[1].split('，')
                                    }
                                    else {
                                      list.product_attribute_name = formula_handleitme.split(':')[1]
                                    }
                                  }
                                })
                              }
                            }
                          }))
                        }
                      })
                    }
                    // 对数量大于零的配件进行公式计算
                    if (itme.sun>0){
                      this.onAccessoriesinput(itme.Identification)
                    }
                  })
                }
              })
            }
            //按产品数量和价格初始化配件价格
            this.oninput()

            // 请求产品组合属性
            this.getGroupAttribute(LocalShoppingCart.product_id,LocalShoppingCart.attribute_group_id)


            let canvas = this.$refs.canvasF
            if (this.detail.product_quotation_style_type === '6'){
              canvas.height = 600
            }
            else if (this.detail.product_quotation_style_type === '4'){
              canvas.height = canvas.width*1.3
            }
            else {
              canvas.height = 300
            }
            canvas.width = this.$refs.canvasHW.offsetWidth - 20
            this.canvasTxt = canvas.getContext('2d')
            //图片加载完后，将其显示在canvas中
            let _this = this
            this.$refs.p_img.setAttribute('crossOrigin', 'anonymous');
            this.$refs.p_img.src = LocalShoppingCart.canvas_img_data;
            this.$refs.p_img.onload = function () {
              _this.canvasTxt.drawImage(this, 0, 0)
              // context.drawImage(this, 0, 0, 1080, 980)改变图片大小到1080*980
            }
            this.$refs.original_graph_img.setAttribute('crossOrigin', 'anonymous');
            this.$refs.original_graph_img.src = LocalShoppingCart.canvas_img_data;
            this.$refs.original_graph_img.onload = function () {
              _this.original_graph = this
            }
          })

        },
        methods:{
          //请求组合属性方法
          getGroupAttribute(id,attrid){
            getProductAttributeGroupPrice(id).then(data=>{
              if (data.status && data.data!==null) {
                // this.productAttribute
                this.combinationattributes = data.data
                let attribute_id_group = []
                this.combinationattributes.map((itme,index)=>{
                  let a = itme.attribute_id_group.split(',')
                  attribute_id_group = attribute_id_group.concat(a)
                  if (attrid){
                    if (itme.id === attrid.toString()){
                      this.attribute_group_value = index  //产品组合属性
                      this.detail.expend_price = itme.attribute_group_price
                      this.detail.attribute_group_id = attrid //产品组合属性id
                    }
                  }
                })
                attribute_id_group = Array.from(new Set(attribute_id_group))
                attribute_id_group.map(itme=>{
                  this.productAttribute.map(list=>{
                    if (itme === list.attribute_id) {
                      list.group_sign = true
                    }
                  })
                })
              }
              // 调用选择计算方法
              this.oninput()
            })
          },
          S4() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
          },
          guid() {
            return (this.S4()+this.S4());
          },
          inorderlist(){
            this.$store.commit('set_inorderilstroutername','shop?id='+this.$route.query.id)
            this.$router.push({ path: '/orderlist'});
          },
          showPersonalCenter(){
            this.popupVisible ? this.popupVisible = false : this.popupVisible = true
          },
          //减少主产品数量
          productreduce(){
            this.num>1?this.num-=1:'';
            //数量变化请求接口，判断是否改变产品单价，如果是，调用计算公式
            getProActionPrice(this.detail.product_id,this.num).then(data=>{
              if (this.detail.expend_price !== data.price) {
                this.detail.expend_price = data.price
                this.oninput()
              }
              else {
                this.product_reduce_add()
              }
            })
          },
          //增加主产品数量
          productadd(){
            this.num+=1;
            //数量变化请求接口，判断是否改变产品单价，如果是，调用计算公式
            getProActionPrice(this.detail.product_id,this.num).then(data=>{
              if (this.detail.expend_price !== data.price) {
                this.detail.expend_price = data.price
                this.oninput()
              }
              else {
                this.product_reduce_add()
              }
            })
          },
          curtainlogout(){
            curtainlogout().then(data=>{
              sessionStorage.removeItem('LocalShoppingCart');
              sessionStorage.removeItem('order_id');
              sessionStorage.removeItem('quotation_code');
              localStorage.removeItem('logindata');
              localStorage.removeItem('userdata');
              this.$store.commit('res_state')
              this.$router.push({ path: '/'});
            })
          },
          //匹配产品的数值范围
          onSizerange(e){
            let attribute_id = e.target.getAttribute('data-attribute_id')
            let min = Number.parseFloat(e.target.getAttribute('data-min'))
            let max =Number.parseFloat(e.target.getAttribute('data-max'))
            this.productAttribute.map((itme)=>{
              if (itme.attribute_id === attribute_id) {
                if(min && itme.product_attribute_name < min){
                  this.$set(itme,'go_beyond',this.detail.product_name + '的最小'+itme.product_attribute_name_title + '为' + min)
                }
                else if (max && itme.product_attribute_name > max) {
                  this.$set(itme,'go_beyond',this.detail.product_name + '的最大'+itme.product_attribute_name_title + '为' + max)
                }
                else {
                  this.$set(itme,'go_beyond','')
                }
              }
            })

          },
          //产品的计算公式调用
          oninput(){
            let obj={
              formula_id:this.detail.product_formula_id,
              product_id:this.detail.product_id,
              attr_id:this.detail.product_attribute_ids
            }
            if (typeof this.productAttribute !== 'object') {
              this.$set(this.detail,'result',this.detail.expend_price)
              return
            }
            let attribute_value_group = []; //组合属性名称
            for (let i=0;i<this.productAttribute.length;i++){
              // 同步选择组合属性
              if (this.productAttribute[i].group_sign) {
                attribute_value_group.push(this.productAttribute[i].product_attribute_name)
              }
              //下拉框的选项为'() 或 （）'时变为输入框
              if (this.productAttribute[i].product_attribute_name ===  '（）' || this.productAttribute[i].product_attribute_name === '()' || this.productAttribute[i].product_attribute_name === 'Other'){
                this.productAttribute[i].product_attribute_name = ''
                delete this.productAttribute[i].attribute_list
              }
              // 下拉框值的後面是一個括號時
              if (this.productAttribute[i].product_attribute_name.slice(-2)=== '()' || this.productAttribute[i].product_attribute_name.slice(-2) === '（）'){
                this.productAttribute[i].spare_attribute_list = JSON.parse(JSON.stringify(this.productAttribute[i].attribute_list))
                delete this.productAttribute[i].attribute_list
              }

              if (this.productAttribute[i].product_attribute_name === '') {
                obj['formula_'+this.productAttribute[i].attribute_id] = 0
              }
              else if (this.productAttribute[i].in_formula===1) {
                obj['formula_'+this.productAttribute[i].attribute_id] = this.productAttribute[i].product_attribute_name
              }
            }
            // 循环组合属性查找对应的组合属性值
            if (this.combinationattributes){
              this.combinationattributes.map(itme=>{
                let a = itme.attribute_value_group.split('-')
                let b = a[a.length-1].split('×')
                let sum = 0
                attribute_value_group.map(list=>{
                  b.map(list1=>{
                    if (list === list1) {
                      sum += 1
                    }
                  })
                })
                if (sum === attribute_value_group.length){
                  this.detail.attribute_group_id = itme.id //产品组合属性id
                  this.detail.expend_price = itme.attribute_group_price

                }
              })
            }
            productFormula(obj).then((data)=>{
              if (data.status){
                this.$set(this.detail,'result',data.info.result*this.detail.expend_price)
              }
              else {
                this.$set(this.detail,'result',1*this.detail.expend_price)
              }
              this.product_reduce_add()
            })
          },
          //隐藏和显示产品计算公式
          showcomputedbox(e){
            if (e.target.parentNode.style.height == '' || e.target.parentNode.style.height === '10px'){
              e.target.parentNode.style.height = 'auto'
            }
            else {
              e.target.parentNode.style.height = '10px'
            }
          },
          //主产品数量变化时重新计算配件的价格
          product_reduce_add(){
            if (typeof this.productAccessories === 'object'){
              //初始化配件
              this.productAccessories.map((itme)=>{
                //是否使用百分比计算配件价格
                if (itme.productAccessoriesPointType === '1' && !itme.composite_attribute_value){
                  itme.productAccessoriesPrice = Math.ceil((this.detail.result*this.num)*(itme.productAccessoriesPoint/100)).toFixed(2)
                  //配件价格改变,如果已选择则重新调用公式计算
                  if (itme.sun>0){
                    this.onAccessoriesinput(itme.Identification)
                  }
                }
                //初始化子配件
                if (typeof itme.partsInPartsData === 'object') {
                  itme.partsInPartsData.map((itme2)=>{
                    //是否使用百分比计算配件价格
                    if (itme2.productAccessoriesPointType === '1' && !itme2.composite_attribute_value){
                      itme2.productAccessoriesPrice = Math.ceil((this.detail.result*this.num)*(itme2.productAccessoriesPoint/100)).toFixed(2)
                      //配件价格改变,如果已选择则重新调用公式计算
                      if (itme2.sun>0){
                        this.onAccessoriesinput(itme2.Identification)
                      }
                    }
                    //初始化第三级配件
                    if (typeof itme2.sub_level_data === 'object') {
                      itme2.sub_level_data.map((itme3)=>{
                        //是否使用百分比计算配件价格
                        if (itme3.productAccessoriesPointType === '1' && !itme3.composite_attribute_value){
                          itme3.second_price = Math.ceil((this.detail.result*this.num)*(itme3.productAccessoriesPoint/100)).toFixed(2)
                          //配件价格改变,如果已选择则重新调用公式计算
                          if (itme3.sun>0){
                            this.onAccessoriesinput(itme3.Identification)
                          }
                        }
                        //初始化第四级配件
                        if (typeof itme3.sub_level_data === 'object') {
                          itme3.sub_level_data.map((itme4)=>{
                            //是否使用百分比计算配件价格
                            if (itme4.productAccessoriesPointType === '1' && !itme4.composite_attribute_value){
                              itme4.second_price = Math.ceil((this.detail.result*this.num)*(itme4.productAccessoriesPoint/100)).toFixed(2)
                              //配件价格改变,如果已选择则重新调用公式计算
                              if (itme4.sun>0){
                                this.onAccessoriesinput(itme4.Identification)
                              }
                            }
                            //初始化第五级配件
                            if (typeof itme4.sub_level_data === 'object') {
                              itme4.sub_level_data.map((itme5)=>{
                                //是否使用百分比计算配件价格
                                if (itme5.productAccessoriesPointType === '1' && !itme5.composite_attribute_value){
                                  itme5.second_price = Math.ceil((this.detail.result*this.num)*(itme5.productAccessoriesPoint/100)).toFixed(2)
                                  //配件价格改变,如果已选择则重新调用公式计算
                                  if (itme5.sun>0){
                                    this.onAccessoriesinput(itme5.Identification)
                                  }
                                }
                                //初始化第六级配件
                                if (typeof itme5.sub_level_data === 'object') {
                                  itme5.sub_level_data.map((itme6)=>{
                                    //是否使用百分比计算配件价格
                                    if (itme6.productAccessoriesPointType === '1' && !itme6.composite_attribute_value){
                                      itme6.second_price = Math.ceil((this.detail.result*this.num)*(itme6.productAccessoriesPoint/100)).toFixed(2)
                                      //配件价格改变,如果已选择则重新调用公式计算
                                      if (itme6.sun>0){
                                        this.onAccessoriesinput(itme6.Identification)
                                      }
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          },
          //选择配件
          onselect(id) {
            // console.log(Identification)
            if (typeof this.productAccessories === 'object') {
              this.productAccessories.map((productAccessories_itme, index) => {
                if (typeof productAccessories_itme.productAccessories === 'object') {
                  productAccessories_itme.productAccessories.map((itme,i)=>{
                    // 判断是否是第一级子配件
                    if (id === itme.product_id) {
                      if (itme.select === 'active') {
                        itme.select = ''
                        if (itme.product_name === this.showspartsname2) {
                          this.showsparts2 = []
                          this.showsparts3 = []
                          this.showsparts4 = []
                          this.showsparts5 = []
                          this.showsparts6 = []
                        }
                        productAccessories_itme.productAccessories.splice(i, 1, itme)
                      }
                      else {
                        // 配件只允許選擇一個
                        productAccessories_itme.productAccessories.map(list=>{
                          list.sun = 0
                          list.select = ''
                        })
                        itme.select = 'active'
                        if (typeof itme.partsInPartsData === 'object') {
                          this.showsparts2 = itme.partsInPartsData
                          this.showspartsname2 = itme.product_name
                          this.showsparts3 = []
                        }
                        else {
                          this.showsparts2 = []
                          this.showsparts3 = []
                          this.showsparts4 = []
                          this.showsparts5 = []
                          this.showsparts6 = []
                        }
                        if (Number.parseInt(itme.sun) === 0) {
                          itme.sun = 1
                        }
                        productAccessories_itme.productAccessories.splice(i, 1, itme)
                        return;
                      }
                    }
                    else {
                      // 如果不是循环第二级子配件
                      if (typeof itme.partsInPartsData === 'object'){
                        itme.partsInPartsData.map((itme2)=>{
                          // 判断是不是二级配件
                          if (Identification === itme2.Identification){
                            if (itme2.select === 'active') {
                              itme2.select = ''
                              if (itme2.product_name === this.showspartsname3) {
                                this.showsparts3 = []
                                this.showsparts4 = []
                                this.showsparts5 = []
                                this.showsparts6 = []
                              }
                              this.productAccessories.splice(i,1,itme)
                            }
                            else {
                              itme2.select = 'active'
                              this.onAccessoriesinput(Identification) //选中时计算产品价格
                              if (typeof itme2.sub_level_data === 'object'){
                                this.showsparts3 = itme2.sub_level_data
                                this.showspartsname3 = itme2.product_name
                                this.showsparts4 = []
                              }
                              else {
                                this.showsparts3 = []
                                this.showsparts4 = []
                                this.showsparts5 = []
                                this.showsparts6 = []
                              }
                              //清除子配件的选择状态
                              if (typeof itme2.partsInPartsData === 'object'){
                                itme2.partsInPartsData.map((list)=>{
                                  if (typeof list.sub_level_data === 'object') {
                                    // 循环第三级配件，清除第三级子配件的选择状态
                                    list.sub_level_data.map(list2=>{
                                      list2.select = ''
                                    })
                                  }
                                })
                              }
                              if (Number.parseInt(itme2.sun)===0) {
                                itme2.sun = 1
                              }
                              this.productAccessories.splice(i,1,itme)
                              return;
                            }
                          }
                          else {
                            // 循环第三级配件
                            if (typeof itme2.sub_level_data === 'object'){
                              itme2.sub_level_data.map((itme3)=>{
                                // 判断是不是三级配件
                                if (Identification === itme3.Identification){
                                  if (itme3.select === 'active') {
                                    itme3.select = ''
                                    if (itme3.name === this.showspartsname4) {
                                      this.showsparts4 = []
                                      this.showsparts5 = []
                                      this.showsparts6 = []
                                    }
                                    this.productAccessories.splice(i,1,itme)
                                  }
                                  else {
                                    itme3.select = 'active'
                                    this.onAccessoriesinput(itme3.Identification) //选中时计算产品价格
                                    if (typeof itme3.sub_level_data === 'object'){
                                      this.showsparts4 = itme3.sub_level_data
                                      this.showspartsname4 = itme3.name
                                      this.showsparts5 = []
                                    }
                                    else {
                                      this.showsparts4 = []
                                      this.showsparts5 = []
                                      this.showsparts6 = []
                                    }
                                    //清除子配件的选择状态
                                    if (typeof itme3.sub_level_data === 'object'){
                                      itme3.sub_level_data.map((list)=>{
                                        if (typeof list.sub_level_data === 'object') {
                                          // 循环第三级配件，清除第三级子配件的选择状态
                                          list.sub_level_data.map(list2=>{
                                            list2.select = ''
                                          })
                                        }
                                      })
                                    }
                                    if (Number.parseInt(itme3.sun)===0) {
                                      itme3.sun = 1
                                    }
                                    this.productAccessories.splice(i,1,itme)
                                    return;
                                  }
                                }
                                else {
                                  // 循环第四级配件
                                  if (typeof itme3.sub_level_data === 'object'){
                                    itme3.sub_level_data.map((itme4)=>{
                                      // 判断是不是四级配件
                                      if (Identification === itme4.Identification){
                                        if (itme4.select === 'active') {
                                          itme4.select = ''
                                          if (itme4.name === this.showspartsname5) {
                                            this.showsparts5 = []
                                            this.showsparts6 = []
                                          }
                                          this.productAccessories.splice(i,1,itme)
                                        }
                                        else {
                                          itme4.select = 'active'
                                          this.onAccessoriesinput(itme4.Identification) //选中时计算产品价格
                                          if (typeof itme4.sub_level_data === 'object'){
                                            this.showsparts5 = itme4.sub_level_data
                                            this.showspartsname5 = itme4.name
                                            this.showsparts6 = []
                                            console.log(this.showsparts5)
                                          }
                                          else {
                                            this.showsparts5 = []
                                            this.showsparts6 = []
                                          }
                                          //清除子配件的选择状态
                                          if (typeof itme4.sub_level_data === 'object'){
                                            itme4.sub_level_data.map((list)=>{
                                              if (typeof list.sub_level_data === 'object') {
                                                // 循环第三级配件，清除第三级子配件的选择状态
                                                list.sub_level_data.map(list2=>{
                                                  list2.select = ''
                                                })
                                              }
                                            })
                                          }
                                          if (Number.parseInt(itme4.sun)===0) {
                                            itme4.sun = 1
                                          }
                                          this.productAccessories.splice(i,1,itme)
                                          return;
                                        }
                                      }
                                      else {
                                        // 循环第五级配件
                                        if (typeof itme4.sub_level_data === 'object'){
                                          itme4.sub_level_data.map((itme5)=>{
                                            // 判断是不是五级配件
                                            if (Identification === itme5.Identification){
                                              if (itme5.select === 'active') {
                                                itme5.select = ''
                                                if (itme5.name === this.showspartsname6) {
                                                  this.showsparts6 = []
                                                }
                                                this.productAccessories.splice(i,1,itme)
                                              }
                                              else {
                                                itme5.select = 'active'
                                                this.onAccessoriesinput(itme5.Identification) //选中时计算产品价格
                                                if (typeof itme5.sub_level_data === 'object'){
                                                  this.showsparts6 = itme5.sub_level_data
                                                  this.showspartsname6 = itme5.name
                                                }
                                                else {
                                                  this.showsparts6 = []
                                                }
                                                //清除子配件的选择状态
                                                if (typeof itme5.sub_level_data === 'object'){
                                                  itme5.sub_level_data.map((list)=>{
                                                    if (typeof list.sub_level_data === 'object') {
                                                      // 循环第三级配件，清除第三级子配件的选择状态
                                                      list.sub_level_data.map(list2=>{
                                                        list2.select = ''
                                                      })
                                                    }
                                                  })
                                                }
                                                if (Number.parseInt(itme5.sun)===0) {
                                                  itme5.sun = 1
                                                }
                                                this.productAccessories.splice(i,1,itme)
                                                return;
                                              }
                                            }
                                            else {
                                              // 循环第六级配件
                                              if (typeof itme5.sub_level_data === 'object'){
                                                itme5.sub_level_data.map((itme6)=>{
                                                  // 判断是不是第六级配件
                                                  if (Identification === itme6.Identification){
                                                    if (itme6.select === 'active') {
                                                      itme6.select = ''
                                                      if (itme6.name === this.showspartsname2) {
                                                        this.showsparts6 = []
                                                      }
                                                      this.productAccessories.splice(i,1,itme)
                                                    }
                                                    else {
                                                      itme6.select = 'active'
                                                      this.onAccessoriesinput(itme6.Identification) //选中时计算产品价格
                                                      // if (typeof itme6.sub_level_data === 'object'){
                                                      //   this.showsparts6 = itme6.sub_level_data
                                                      //   this.showspartsname6 = itme6.name
                                                      // }
                                                      // else {
                                                      //   this.showsparts6 = []
                                                      // }
                                                      //清除子配件的选择状态
                                                      // if (typeof itme6.sub_level_data === 'object'){
                                                      //   itme6.sub_level_data.map((list)=>{
                                                      //     if (typeof list.sub_level_data === 'object') {
                                                      //       // 循环第三级配件，清除第三级子配件的选择状态
                                                      //       list.sub_level_data.map(list2=>{
                                                      //         list2.select = ''
                                                      //       })
                                                      //     }
                                                      //   })
                                                      // }
                                                      if (Number.parseInt(itme6.sun)===0) {
                                                        itme6.sun = 1
                                                      }
                                                      this.productAccessories.splice(i,1,itme)
                                                      return;
                                                    }
                                                  }
                                                  else {
                                                    // 循环第七级配件

                                                  }
                                                })
                                              }
                                            }
                                          })
                                        }
                                      }
                                    })
                                  }
                                }
                              })
                            }
                          }
                        })
                      }
                    }
                  })
                }
              })
            }
          },
          //添加配件数量
          onadd(Identification){
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme,i)=>{
                // 判断是否是第一级配件
                if (Identification === itme.Identification){
                  itme.sun += 1
                  this.productAccessories.splice(i,1,itme)
                }
                else {
                  // 循环第二级配件
                  if (typeof itme.partsInPartsData === 'object'){
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是否是第二级的配件
                      if (itme2.Identification === Identification){
                        itme2.sun += 1
                        this.productAccessories.splice(i,1,itme)
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object') {
                          itme2.sub_level_data.map(itme3=>{
                            // 判断是否是第三级配件
                            if (itme3.Identification === Identification) {
                              itme3.sun += 1
                              this.productAccessories.splice(i,1,itme)
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object') {
                                itme3.sub_level_data.map(itme4=>{
                                  // 判断是否是第四级配件
                                  if (itme4.Identification === Identification) {
                                    itme4.sun += 1
                                    this.productAccessories.splice(i,1,itme)
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object') {
                                      itme4.sub_level_data.map(itme5=>{
                                        // 判断是否是第五级配件
                                        if (itme5.Identification === Identification) {
                                          itme5.sun += 1
                                          this.productAccessories.splice(i,1,itme)
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object') {
                                            itme5.sub_level_data.map(itme6=>{
                                              // 判断是否是第六级配件
                                              if (itme6.Identification === Identification) {
                                                itme6.sun += 1
                                                this.productAccessories.splice(i,1,itme)
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }

                }
              })
            }
          },
          //减少配件数量
          onreduce(Identification){
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme,i)=>{
                // 判断是否是第一级配件
                if (Identification === itme.Identification){
                  if (itme.sun>1) {
                    itme.sun -= 1
                  }
                  else if (Number.parseInt(itme.sun)===1) {
                    itme.sun -= 1
                    itme.select = ''

                    if (itme.product_name === this.showspartsname2) {
                      this.showsparts2 = []
                      this.showsparts3 = []
                      this.showsparts4 = []
                      this.showsparts5 = []
                      this.showsparts6 = []
                    }
                    //清除子配件的选择状态
                    if (typeof itme.partsInPartsData === 'object'){
                      itme.partsInPartsData.map((itme2)=>{
                        itme2.select = ''
                        if (typeof itme2.sub_level_data === 'object') {
                          // 循环第三级配件，清除第三级子配件的选择状态
                          itme2.sub_level_data.map(list=>{
                            list.select = ''
                          })
                        }
                      })
                    }
                  }
                  this.productAccessories.splice(i,1,itme)
                }
                else {
                  // 循环第二级配件
                  if (typeof itme.partsInPartsData === 'object'){
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是不是第二级配件
                      if (itme2.Identification === Identification){
                        if (itme2.sun>1){
                          itme2.sun -= 1
                        }
                        else if (Number.parseInt(itme2.sun)===1) {
                          itme2.sun -= 1
                          itme2.select = ''
                          if (itme2.product_name === this.showspartsname3) {
                            this.showsparts3 = []
                            this.showsparts4 = []
                            this.showsparts5 = []
                            this.showsparts6 = []
                          }
                          if (typeof itme2.sub_level_data === 'object') {
                            // 循环第三级配件，清除第三级子配件的选择状态
                            itme2.sub_level_data.map(itme2=>{
                              itme2.select = ''
                            })
                          }
                        }
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object') {
                          itme2.sub_level_data.map(itme3=>{
                            // 判断是不是第三级配件
                            if (itme3.Identification === Identification) {
                              if (itme3.sun>1){
                                itme3.sun -= 1
                              }
                              else if (Number.parseInt(itme3.sun)===1) {
                                itme3.sun -= 1
                                itme3.select = ''
                                if (itme3.name === this.showspartsname4) {
                                  this.showsparts4 = []
                                  this.showsparts5 = []
                                  this.showsparts6 = []
                                }
                                if (typeof itme3.sub_level_data === 'object') {
                                  // 循环第三级配件，清除第三级子配件的选择状态
                                  itme2.sub_level_data.map(itme2=>{
                                    itme2.select = ''
                                  })
                                }
                              }
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object') {
                                itme3.sub_level_data.map(itme4=>{
                                  // 判断是不是第四级配件
                                  if (itme4.Identification === Identification) {
                                    if (itme4.sun>1){
                                      itme4.sun -= 1
                                    }
                                    else if (Number.parseInt(itme4.sun)===1) {
                                      itme4.sun -= 1
                                      itme4.select = ''
                                      if (itme4.name === this.showspartsname5) {
                                        this.showsparts5 = []
                                        this.showsparts6 = []
                                      }
                                      if (typeof itme4.sub_level_data === 'object') {
                                        // 循环第三级配件，清除第三级子配件的选择状态
                                        itme4.sub_level_data.map(itme2=>{
                                          itme2.select = ''
                                        })
                                      }
                                    }
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object') {
                                      itme4.sub_level_data.map(itme5=>{
                                        // 判断是不是第五级配件
                                        if (itme5.Identification === Identification) {
                                          if (itme5.sun>1){
                                            itme5.sun -= 1
                                          }
                                          else if (Number.parseInt(itme5.sun)===1) {
                                            itme5.sun -= 1
                                            itme5.select = ''
                                            if (itme5.name === this.showspartsname6) {
                                              this.showsparts6 = []
                                            }
                                            if (typeof itme5.sub_level_data === 'object') {
                                              // 循环第三级配件，清除第三级子配件的选择状态
                                              itme5.sub_level_data.map(itme2=>{
                                                itme2.select = ''
                                              })
                                            }
                                          }
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object') {
                                            itme5.sub_level_data.map(itme6=>{
                                              // 判断是不是第四级配件
                                              if (itme6.Identification === Identification) {
                                                if (itme6.sun>1){
                                                  itme6.sun -= 1
                                                }
                                                else if (Number.parseInt(itme6.sun)===1) {
                                                  itme6.sun -= 1
                                                  itme6.select = ''
                                                  if (typeof itme6.sub_level_data === 'object') {
                                                    // 循环第三级配件，清除第三级子配件的选择状态
                                                    itme6.sub_level_data.map(itme2=>{
                                                      itme2.select = ''
                                                    })
                                                  }
                                                }
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                    this.productAccessories.splice(i,1,itme)
                  }
                }
              })
            }
          },
          //配件的计算公式调用
          onAccessoriesinput(Identification){
            if (typeof this.productAccessories === 'object') {
              this.productAccessories.map((itme,index)=>{
                // 判断是否是一级配件
                if (Identification === itme.Identification) {
                  // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                  if (itme.composite_attribute_value && itme.AttributeGroup){
                    itme.AttributeGroup.map(list=>{
                      if (list.id === itme.composite_attribute_value){
                        itme.productAccessoriesPrice = list.attribute_group_price
                        // 同步组合属性和原属性
                        // list.attribute_id_group.split(',').map((asttr,index)=>{
                        //   itme.productAttribute.map(prooattr=>{
                        //     if (asttr === prooattr.attribute_id) {
                        //       prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                        //     }
                        //   })
                        // })
                      }
                    })
                  }
                  else {
                    getProductAttributeGroupPrice(itme.product_id).then(data=>{
                      if (data.data){
                        itme.AttributeGroup = data.data
                        if (itme.composite_attribute_value){
                        }
                        // 将组合属性中已经出现的属性禁止修改
                        let attribute_id_group = []
                        itme.AttributeGroup.map(Groupitme=>{
                          let a = Groupitme.attribute_id_group.split(',')
                          attribute_id_group = attribute_id_group.concat(a)

                        })
                        attribute_id_group = Array.from(new Set(attribute_id_group))
                        attribute_id_group.map(group_itme=>{
                          itme.productAttribute.map(list=>{
                            if (group_itme === list.attribute_id) {
                              list.group_sign = true
                            }
                          })
                        })
                        // 如果产品有属性，遍历属性选择属性默认值的组合属性
                        if (typeof itme.productAttribute === 'object') {
                          let attribute_value_group = []; //组合属性名称
                          for (let i=0;i<itme.productAttribute.length;i++){
                            // 同步选择组合属性
                            if (itme.productAttribute[i].group_sign) {
                              attribute_value_group.push(itme.productAttribute[i].product_attribute_name)
                            }
                          }
                          // 循环组合属性查找对应的组合属性值
                          if (itme.AttributeGroup){
                            itme.AttributeGroup.map(itme_Group=>{
                              let a = itme_Group.attribute_value_group.split('-')
                              let b = a[a.length-1].split('×')
                              let sum = 0
                              attribute_value_group.map(list=>{
                                b.map(list1=>{
                                  if (list === list1) {
                                    sum += 1
                                  }
                                })
                              })
                              if (sum === attribute_value_group.length){
                                itme.composite_attribute_value = itme_Group.id //产品组合属性id
                                itme.productAccessoriesPrice = itme_Group.attribute_group_price
                              }
                            })
                          }
                        }
                      }
                    })
                  }
                  if (typeof itme.productAttribute === 'object') {
                    obj.formula_id =itme.product_formula_id
                    obj.product_id =itme.product_id
                    obj.attr_id=itme.product_attribute_ids
                    let attribute_value_group = []; //组合属性名称
                    for (let i=0;i<itme.productAttribute.length;i++){
                      // 同步选择组合属性
                      if (itme.productAttribute[i].group_sign) {
                        attribute_value_group.push(itme.productAttribute[i].product_attribute_name)
                      }
                      //下拉框的选项为'() 或 （）'时变为输入框
                      if (itme.productAttribute[i].product_attribute_name ===  '（）' || itme.productAttribute[i].product_attribute_name === '()'){
                        itme.productAttribute[i].product_attribute_name = ''
                        delete itme.productAttribute[i].attribute_list
                      }
                      if (itme.productAttribute[i].product_attribute_name === '') {
                        obj['formula_'+itme.productAttribute[i].attribute_id] = 0
                      }
                      //是计算属性才传入
                      else if (itme.productAttribute[i].in_formula===1) {
                        obj['formula_'+itme.productAttribute[i].attribute_id] = itme.productAttribute[i].product_attribute_name
                      }
                    }
                    // 循环组合属性查找对应的组合属性值
                    if (itme.AttributeGroup){
                      itme.AttributeGroup.map(itme_Group=>{
                        let a = itme_Group.attribute_value_group.split('-')
                        let b = a[a.length-1].split('×')
                        let sum = 0
                        attribute_value_group.map(list=>{
                          b.map(list1=>{
                            if (list === list1) {
                              sum += 1
                            }
                          })
                        })
                        if (sum === attribute_value_group.length){
                          itme.composite_attribute_value = itme_Group.id //产品组合属性id
                          itme.productAccessoriesPrice = itme_Group.attribute_group_price
                        }
                      })
                    }
                    productFormula(obj).then((data)=>{
                      if (data.status){
                        itme.result = data.info.result * itme.productAccessoriesPrice
                      }
                      else {
                        itme.result = 1 * itme.productAccessoriesPrice
                      }
                      this.$set(this.productAccessories,index,itme)
                    })
                  }
                  else {
                    itme.result = itme.productAccessoriesPrice
                  }
                }
                else {
                  // // 循环二级配件
                  if (typeof itme.partsInPartsData === 'object') {
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是否是二级配件
                      if (Identification === itme2.Identification) {
                        // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                        if (itme2.composite_attribute_value && itme2.AttributeGroup){
                          itme2.AttributeGroup.map(list=>{
                            if (list.id === itme2.composite_attribute_value){
                              itme2.productAccessoriesPrice = list.attribute_group_price
                              // 同步组合属性和原属性
                              // list.attribute_id_group.split(',').map((asttr,index)=>{
                              //   itme2.productAttribute.map(prooattr=>{
                              //     if (asttr === prooattr.attribute_id) {
                              //       prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                              //     }
                              //   })
                              // })
                            }
                          })
                        }
                        else {
                          getProductAttributeGroupPrice(itme2.product_id).then(data=>{
                            if (data.data){
                              itme2.AttributeGroup = data.data
                              // 将组合属性中已经出现的属性禁止修改
                              let attribute_id_group = []
                              itme2.AttributeGroup.map(Groupitme=>{
                                let a = Groupitme.attribute_id_group.split(',')
                                attribute_id_group = attribute_id_group.concat(a)
                              })
                              attribute_id_group = Array.from(new Set(attribute_id_group))
                              attribute_id_group.map(group_itme=>{
                                itme2.productAttribute.map(list=>{
                                  if (group_itme === list.attribute_id) {
                                    list.group_sign = true
                                  }
                                })
                              })
                              // 如果产品有属性，遍历属性选择属性默认值的组合属性
                              if (typeof itme2.productAttribute === 'object') {
                                let attribute_value_group = []; //组合属性名称
                                for (let i=0;i<itme2.productAttribute.length;i++){
                                  // 同步选择组合属性
                                  if (itme2.productAttribute[i].group_sign) {
                                    attribute_value_group.push(itme2.productAttribute[i].product_attribute_name)
                                  }
                                }
                                // 循环组合属性查找对应的组合属性值
                                if (itme2.AttributeGroup){
                                  itme2.AttributeGroup.map(itme_Group=>{
                                    let a = itme_Group.attribute_value_group.split('-')
                                    let b = a[a.length-1].split('×')
                                    let sum = 0
                                    attribute_value_group.map(list=>{
                                      b.map(list1=>{
                                        if (list === list1) {
                                          sum += 1
                                        }
                                      })
                                    })
                                    if (sum === attribute_value_group.length){
                                      itme2.composite_attribute_value = itme_Group.id //产品组合属性id
                                      itme2.productAccessoriesPrice = itme_Group.attribute_group_price
                                    }
                                  })
                                }
                              }
                            }
                          })
                        }

                        if (typeof itme2.productAttribute === 'object') {
                          obj.formula_id =itme2.product_formula_id
                          obj.product_id =itme2.product_id
                          obj.attr_id=itme2.product_attribute_ids
                          let attribute_value_group = []; //组合属性名称
                          for (let i=0;i<itme2.productAttribute.length;i++){
                            // 同步选择组合属性
                            if (itme2.productAttribute[i].group_sign) {
                              attribute_value_group.push(itme2.productAttribute[i].product_attribute_name)
                            }
                            //下拉框的选项为'() 或 （）'时变为输入框
                            if (itme2.productAttribute[i].product_attribute_name ===  '（）' || itme2.productAttribute[i].product_attribute_name === '()'){
                              itme2.productAttribute[i].product_attribute_name = ''
                              delete itme2.productAttribute[i].attribute_list
                            }
                            if (itme2.productAttribute[i].product_attribute_name === '') {
                              obj['formula_'+itme2.productAttribute[i].attribute_id] = 0
                            }
                            //是计算属性才传入
                            else if (itme2.productAttribute[i].in_formula===1) {
                              obj['formula_'+itme2.productAttribute[i].attribute_id] = itme2.productAttribute[i].product_attribute_name
                            }
                          }
                          // 循环组合属性查找对应的组合属性值
                          if (itme2.AttributeGroup){
                            itme2.AttributeGroup.map(itme_Group=>{
                              let a = itme_Group.attribute_value_group.split('-')
                              let b = a[a.length-1].split('×')
                              let sum = 0
                              attribute_value_group.map(list=>{
                                b.map(list1=>{
                                  if (list === list1) {
                                    sum += 1
                                  }
                                })
                              })
                              if (sum === attribute_value_group.length){
                                itme2.composite_attribute_value = itme_Group.id //产品组合属性id
                                itme2.productAccessoriesPrice = itme_Group.attribute_group_price
                              }
                            })
                          }
                          productFormula(obj).then((data)=>{
                            if (data.status){
                              itme2.result = data.info.result * itme2.productAccessoriesPrice
                            }
                            else {
                              itme2.result = 1 * itme2.productAccessoriesPrice
                            }
                            this.$set(this.productAccessories,index,itme)
                          })
                        }
                        else {
                          itme2.result = itme2.productAccessoriesPrice
                        }
                      }
                      else {
                        // 循环三级配件
                        if (typeof itme2.sub_level_data === 'object') {
                          itme2.sub_level_data.map((itme3)=>{
                            // 判断是否是三级配件
                            if (Identification === itme3.Identification) {
                              // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                              if (itme3.composite_attribute_value && itme3.AttributeGroup){
                                itme3.AttributeGroup.map(list=>{
                                  if (list.id === itme3.composite_attribute_value){
                                    itme3.second_price = list.attribute_group_price
                                    // 同步组合属性和原属性
                                    // list.attribute_id_group.split(',').map((asttr,index)=>{
                                    //   itme3.attribute_data.map(prooattr=>{
                                    //     if (asttr === prooattr.attribute_id) {
                                    //       prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                    //     }
                                    //   })
                                    // })
                                  }
                                })
                              }
                              else {
                                getProductAttributeGroupPrice(itme3.product_id).then(data=>{
                                  if (data.data){
                                    itme3.AttributeGroup = data.data

                                    // 将组合属性中已经出现的属性禁止修改
                                    let attribute_id_group = []
                                    itme3.AttributeGroup.map(Groupitme=>{
                                      let a = Groupitme.attribute_id_group.split(',')
                                      attribute_id_group = attribute_id_group.concat(a)
                                    })
                                    attribute_id_group = Array.from(new Set(attribute_id_group))
                                    attribute_id_group.map(group_itme=>{
                                      itme3.attribute_data.map(list=>{
                                        if (group_itme === list.attribute_id) {
                                          list.group_sign = true
                                        }
                                      })
                                    })
                                    // 如果产品有属性，遍历属性选择属性默认值的组合属性
                                    if (typeof itme3.attribute_data === 'object') {
                                      let attribute_value_group = []; //组合属性名称
                                      for (let i=0;i<itme3.attribute_data.length;i++){
                                        // 同步选择组合属性
                                        if (itme3.attribute_data[i].group_sign) {
                                          attribute_value_group.push(itme3.attribute_data[i].product_attribute_name)
                                        }
                                      }
                                      // 循环组合属性查找对应的组合属性值
                                      if (itme3.AttributeGroup){
                                        itme3.AttributeGroup.map(itme_Group=>{
                                          let a = itme_Group.attribute_value_group.split('-')
                                          let b = a[a.length-1].split('×')
                                          let sum = 0
                                          attribute_value_group.map(list=>{
                                            b.map(list1=>{
                                              if (list === list1) {
                                                sum += 1
                                              }
                                            })
                                          })
                                          if (sum === attribute_value_group.length){
                                            itme3.composite_attribute_value = itme_Group.id //产品组合属性id
                                            itme3.second_price = itme_Group.attribute_group_price
                                          }
                                        })
                                      }
                                    }
                                  }
                                })
                              }

                              if (typeof itme3.attribute_data === 'object') {
                                obj.formula_id =itme3.formula_id
                                obj.product_id =itme3.self_id
                                obj.attr_id=itme3.productattribute_ids
                                let attribute_value_group = []; //组合属性名称
                                for (let i=0;i<itme3.attribute_data.length;i++){
                                  // 同步选择组合属性
                                  if (itme3.attribute_data[i].group_sign) {
                                    attribute_value_group.push(itme3.attribute_data[i].product_attribute_name)
                                  }
                                  //下拉框的选项为'() 或 （）'时变为输入框
                                  if (itme3.attribute_data[i].product_attribute_name ===  '（）' || itme3.attribute_data[i].product_attribute_name === '()'){
                                    itme3.attribute_data[i].product_attribute_name = ''
                                    delete itme3.attribute_data[i].attribute_list
                                  }
                                  if (itme3.attribute_data[i].product_attribute_name === '') {
                                    obj['formula_'+itme3.attribute_data[i].attribute_id] = 0
                                  }
                                  //是计算属性才传入
                                  else if (itme3.attribute_data[i].in_formula===1) {
                                    obj['formula_'+itme3.attribute_data[i].attribute_id] = itme3.attribute_data[i].product_attribute_name
                                  }
                                }
                                // 循环组合属性查找对应的组合属性值
                                if (itme3.AttributeGroup){
                                  itme3.AttributeGroup.map(itme_Group=>{
                                    let a = itme_Group.attribute_value_group.split('-')
                                    let b = a[a.length-1].split('×')
                                    let sum = 0
                                    attribute_value_group.map(list=>{
                                      b.map(list1=>{
                                        if (list === list1) {
                                          sum += 1
                                        }
                                      })
                                    })
                                    if (sum === attribute_value_group.length){
                                      itme3.composite_attribute_value = itme_Group.id //产品组合属性id
                                      itme3.second_price = itme_Group.attribute_group_price
                                    }
                                  })
                                }
                                productFormula(obj).then((data)=>{
                                  if (data.status){
                                    itme3.result = data.info.result * itme3.second_price
                                  }
                                  else {
                                    itme3.result = 1 * itme3.second_price
                                  }
                                  this.$set(this.productAccessories,index,itme)
                                })
                              }
                              else {
                                itme3.result = itme3.second_price
                              }
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object') {
                                itme3.sub_level_data.map((itme4)=>{
                                  // 判断是否是四级配件
                                  if (Identification === itme4.Identification) {
                                    // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                                    if (itme4.composite_attribute_value && itme4.AttributeGroup){
                                      itme4.AttributeGroup.map(list=>{
                                        if (list.id === itme4.composite_attribute_value){
                                          itme4.second_price = list.attribute_group_price
                                          // 同步组合属性和原属性
                                          // list.attribute_id_group.split(',').map((asttr,index)=>{
                                          //   itme4.attribute_data.map(prooattr=>{
                                          //     if (asttr === prooattr.attribute_id) {
                                          //       prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                          //     }
                                          //   })
                                          // })
                                        }
                                      })
                                    }
                                    else {
                                      getProductAttributeGroupPrice(itme4.product_id).then(data=>{
                                        if (data.data){
                                          itme4.AttributeGroup = data.data
                                          // 将组合属性中已经出现的属性禁止修改
                                          let attribute_id_group = []
                                          itme4.AttributeGroup.map(Groupitme=>{
                                            let a = Groupitme.attribute_id_group.split(',')
                                            attribute_id_group = attribute_id_group.concat(a)
                                          })
                                          attribute_id_group = Array.from(new Set(attribute_id_group))
                                          attribute_id_group.map(group_itme=>{
                                            itme4.attribute_data.map(list=>{
                                              if (group_itme === list.attribute_id) {
                                                list.group_sign = true
                                              }
                                            })
                                          })
                                          // 如果产品有属性，遍历属性选择属性默认值的组合属性
                                          if (typeof itme4.attribute_data === 'object') {
                                            let attribute_value_group = []; //组合属性名称
                                            for (let i=0;i<itme4.attribute_data.length;i++){
                                              // 同步选择组合属性
                                              if (itme4.attribute_data[i].group_sign) {
                                                attribute_value_group.push(itme4.attribute_data[i].product_attribute_name)
                                              }
                                            }
                                            // 循环组合属性查找对应的组合属性值
                                            if (itme4.AttributeGroup){
                                              itme4.AttributeGroup.map(itme_Group=>{
                                                let a = itme_Group.attribute_value_group.split('-')
                                                let b = a[a.length-1].split('×')
                                                let sum = 0
                                                attribute_value_group.map(list=>{
                                                  b.map(list1=>{
                                                    if (list === list1) {
                                                      sum += 1
                                                    }
                                                  })
                                                })
                                                if (sum === attribute_value_group.length){
                                                  itme4.composite_attribute_value = itme_Group.id //产品组合属性id
                                                  itme4.second_price = itme_Group.attribute_group_price
                                                }
                                              })
                                            }
                                          }
                                        }
                                      })
                                    }

                                    if (typeof itme4.attribute_data === 'object') {
                                      obj.formula_id =itme4.formula_id
                                      obj.product_id =itme4.self_id
                                      obj.attr_id=itme4.productattribute_ids
                                      let attribute_value_group = []; //组合属性名称
                                      for (let i=0;i<itme4.attribute_data.length;i++){
                                        // 同步选择组合属性
                                        if (itme4.attribute_data[i].group_sign) {
                                          attribute_value_group.push(itme4.attribute_data[i].product_attribute_name)
                                        }
                                        //下拉框的选项为'() 或 （）'时变为输入框
                                        if (itme4.attribute_data[i].product_attribute_name ===  '（）' || itme4.attribute_data[i].product_attribute_name === '()'){
                                          itme4.attribute_data[i].product_attribute_name = ''
                                          delete itme4.attribute_data[i].attribute_list
                                        }
                                        if (itme4.attribute_data[i].product_attribute_name === '') {
                                          obj['formula_'+itme4.attribute_data[i].attribute_id] = 0
                                        }
                                        //是计算属性才传入
                                        else if (itme4.attribute_data[i].in_formula===1) {
                                          obj['formula_'+itme4.attribute_data[i].attribute_id] = itme4.attribute_data[i].product_attribute_name
                                        }
                                      }
                                      // 循环组合属性查找对应的组合属性值
                                      if (itme4.AttributeGroup){
                                        itme4.AttributeGroup.map(itme_Group=>{
                                          let a = itme_Group.attribute_value_group.split('-')
                                          let b = a[a.length-1].split('×')
                                          let sum = 0
                                          attribute_value_group.map(list=>{
                                            b.map(list1=>{
                                              if (list === list1) {
                                                sum += 1
                                              }
                                            })
                                          })
                                          if (sum === attribute_value_group.length){
                                            itme4.composite_attribute_value = itme_Group.id //产品组合属性id
                                            itme4.second_price = itme_Group.attribute_group_price
                                          }
                                        })
                                      }
                                      productFormula(obj).then((data)=>{
                                        if (data.status){
                                          itme4.result = data.info.result * itme4.second_price
                                        }
                                        else {
                                          itme4.result = 1 * itme4.second_price
                                        }
                                        this.$set(this.productAccessories,index,itme)
                                      })
                                    }
                                    else {
                                      itme4.result = itme4.second_price
                                    }
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object') {
                                      itme4.sub_level_data.map((itme5)=>{
                                        // 判断是否是五级配件
                                        if (Identification === itme5.Identification) {
                                          // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                                          if (itme5.composite_attribute_value && itme5.AttributeGroup){
                                            itme5.AttributeGroup.map(list=>{
                                              if (list.id === itme5.composite_attribute_value){
                                                itme5.second_price = list.attribute_group_price
                                                // 同步组合属性和原属性
                                                // list.attribute_id_group.split(',').map((asttr,index)=>{
                                                //   itme5.attribute_data.map(prooattr=>{
                                                //     if (asttr === prooattr.attribute_id) {
                                                //       prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                                //     }
                                                //   })
                                                // })
                                              }
                                            })
                                          }
                                          else {
                                            getProductAttributeGroupPrice(itme5.product_id).then(data=>{
                                              if (data.data){
                                                itme5.AttributeGroup = data.data
                                                // 将组合属性中已经出现的属性禁止修改
                                                let attribute_id_group = []
                                                itme5.AttributeGroup.map(Groupitme=>{
                                                  let a = Groupitme.attribute_id_group.split(',')
                                                  attribute_id_group = attribute_id_group.concat(a)
                                                })
                                                attribute_id_group = Array.from(new Set(attribute_id_group))
                                                attribute_id_group.map(group_itme=>{
                                                  itme5.attribute_data.map(list=>{
                                                    if (group_itme === list.attribute_id) {
                                                      list.group_sign = true
                                                    }
                                                  })
                                                })
                                                // 如果产品有属性，遍历属性选择属性默认值的组合属性
                                                if (typeof itme5.attribute_data === 'object') {
                                                  let attribute_value_group = []; //组合属性名称
                                                  for (let i=0;i<itme5.attribute_data.length;i++){
                                                    // 同步选择组合属性
                                                    if (itme5.attribute_data[i].group_sign) {
                                                      attribute_value_group.push(itme5.attribute_data[i].product_attribute_name)
                                                    }
                                                  }
                                                  // 循环组合属性查找对应的组合属性值
                                                  if (itme5.AttributeGroup){
                                                    itme5.AttributeGroup.map(itme_Group=>{
                                                      let a = itme_Group.attribute_value_group.split('-')
                                                      let b = a[a.length-1].split('×')
                                                      let sum = 0
                                                      attribute_value_group.map(list=>{
                                                        b.map(list1=>{
                                                          if (list === list1) {
                                                            sum += 1
                                                          }
                                                        })
                                                      })
                                                      if (sum === attribute_value_group.length){
                                                        itme5.composite_attribute_value = itme_Group.id //产品组合属性id
                                                        itme5.second_price = itme_Group.attribute_group_price
                                                      }
                                                    })
                                                  }
                                                }
                                              }
                                            })
                                          }

                                          if (typeof itme5.attribute_data === 'object') {
                                            obj.formula_id =itme5.formula_id
                                            obj.product_id =itme5.Identification
                                            obj.attr_id=itme5.productattribute_ids
                                            let attribute_value_group = []; //组合属性名称
                                            for (let i=0;i<itme5.attribute_data.length;i++){
                                              // 同步选择组合属性
                                              if (itme5.attribute_data[i].group_sign) {
                                                attribute_value_group.push(itme5.attribute_data[i].product_attribute_name)
                                              }
                                              //下拉框的选项为'() 或 （）'时变为输入框
                                              if (itme5.attribute_data[i].product_attribute_name ===  '（）' || itme5.attribute_data[i].product_attribute_name === '()'){
                                                itme5.attribute_data[i].product_attribute_name = ''
                                                delete itme5.attribute_data[i].attribute_list
                                              }
                                              if (itme5.attribute_data[i].product_attribute_name === '') {
                                                obj['formula_'+itme5.attribute_data[i].attribute_id] = 0
                                              }
                                              //是计算属性才传入
                                              else if (itme5.attribute_data[i].in_formula===1) {
                                                obj['formula_'+itme5.attribute_data[i].attribute_id] = itme5.attribute_data[i].product_attribute_name
                                              }
                                            }
                                            // 循环组合属性查找对应的组合属性值
                                            if (itme5.AttributeGroup){
                                              itme5.AttributeGroup.map(itme_Group=>{
                                                let a = itme_Group.attribute_value_group.split('-')
                                                let b = a[a.length-1].split('×')
                                                let sum = 0
                                                attribute_value_group.map(list=>{
                                                  b.map(list1=>{
                                                    if (list === list1) {
                                                      sum += 1
                                                    }
                                                  })
                                                })
                                                if (sum === attribute_value_group.length){
                                                  itme5.composite_attribute_value = itme_Group.id //产品组合属性id
                                                  itme5.second_price = itme_Group.attribute_group_price
                                                }
                                              })
                                            }
                                            productFormula(obj).then((data)=>{
                                              if (data.status){
                                                itme5.result = data.info.result * itme5.second_price
                                              }
                                              else {
                                                itme5.result = 1 * itme5.second_price
                                              }
                                              this.$set(this.productAccessories,index,itme)
                                            })
                                          }
                                          else {
                                            itme5.result = itme5.second_price
                                          }
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object') {
                                            itme5.sub_level_data.map((itme6)=>{
                                              // 判断是否是第六级配件
                                              if (Identification === itme6.Identification) {
                                                // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                                                if (itme6.composite_attribute_value && itme6.AttributeGroup){
                                                  itme6.AttributeGroup.map(list=>{
                                                    if (list.id === itme6.composite_attribute_value){
                                                      itme6.second_price = list.attribute_group_price
                                                      // 同步组合属性和原属性
                                                      // list.attribute_id_group.split(',').map((asttr,index)=>{
                                                      //   itme6.attribute_data.map(prooattr=>{
                                                      //     if (asttr === prooattr.attribute_id) {
                                                      //       prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                                      //     }
                                                      //   })
                                                      // })
                                                    }
                                                  })
                                                }
                                                else {
                                                  getProductAttributeGroupPrice(itme6.product_id).then(data=>{
                                                    if (data.data){
                                                      itme6.AttributeGroup = data.data
                                                      // 将组合属性中已经出现的属性禁止修改
                                                      let attribute_id_group = []
                                                      itme6.AttributeGroup.map(Groupitme=>{
                                                        let a = Groupitme.attribute_id_group.split(',')
                                                        attribute_id_group = attribute_id_group.concat(a)
                                                      })
                                                      attribute_id_group = Array.from(new Set(attribute_id_group))
                                                      attribute_id_group.map(group_itme=>{
                                                        itme6.attribute_data.map(list=>{
                                                          if (group_itme === list.attribute_id) {
                                                            list.group_sign = true
                                                          }
                                                        })
                                                      })
                                                      // 如果产品有属性，遍历属性选择属性默认值的组合属性
                                                      if (typeof itme6.attribute_data === 'object') {
                                                        let attribute_value_group = []; //组合属性名称
                                                        for (let i=0;i<itme6.attribute_data.length;i++){
                                                          // 同步选择组合属性
                                                          if (itme6.attribute_data[i].group_sign) {
                                                            attribute_value_group.push(itme6.attribute_data[i].product_attribute_name)
                                                          }
                                                        }
                                                        // 循环组合属性查找对应的组合属性值
                                                        if (itme6.AttributeGroup){
                                                          itme6.AttributeGroup.map(itme_Group=>{
                                                            let a = itme_Group.attribute_value_group.split('-')
                                                            let b = a[a.length-1].split('×')
                                                            let sum = 0
                                                            attribute_value_group.map(list=>{
                                                              b.map(list1=>{
                                                                if (list === list1) {
                                                                  sum += 1
                                                                }
                                                              })
                                                            })
                                                            if (sum === attribute_value_group.length){
                                                              itme6.composite_attribute_value = itme_Group.id //产品组合属性id
                                                              itme6.second_price = itme_Group.attribute_group_price
                                                            }
                                                          })
                                                        }
                                                      }
                                                    }
                                                  })
                                                }
                                                if (typeof itme6.attribute_data === 'object') {
                                                  obj.formula_id =itme6.formula_id
                                                  obj.product_id =itme6.self_id
                                                  obj.attr_id=itme6.productattribute_ids
                                                  let attribute_value_group = []; //组合属性名称
                                                  for (let i=0;i<itme6.attribute_data.length;i++){
                                                    // 同步选择组合属性
                                                    if (itme6.attribute_data[i].group_sign) {
                                                      attribute_value_group.push(itme6.attribute_data[i].product_attribute_name)
                                                    }
                                                    //下拉框的选项为'() 或 （）'时变为输入框
                                                    if (itme6.attribute_data[i].product_attribute_name ===  '（）' || itme6.attribute_data[i].product_attribute_name === '()'){
                                                      itme6.attribute_data[i].product_attribute_name = ''
                                                      delete itme6.attribute_data[i].attribute_list
                                                    }
                                                    if (itme6.attribute_data[i].product_attribute_name === '') {
                                                      obj['formula_'+itme6.attribute_data[i].attribute_id] = 0
                                                    }
                                                    //是计算属性才传入
                                                    else if (itme6.attribute_data[i].in_formula===1) {
                                                      obj['formula_'+itme6.attribute_data[i].attribute_id] = itme6.attribute_data[i].product_attribute_name
                                                    }
                                                  }
                                                  // 循环组合属性查找对应的组合属性值
                                                  if (itme6.AttributeGroup){
                                                    itme6.AttributeGroup.map(itme_Group=>{
                                                      let a = itme_Group.attribute_value_group.split('-')
                                                      let b = a[a.length-1].split('×')
                                                      let sum = 0
                                                      attribute_value_group.map(list=>{
                                                        b.map(list1=>{
                                                          if (list === list1) {
                                                            sum += 1
                                                          }
                                                        })
                                                      })
                                                      if (sum === attribute_value_group.length){
                                                        itme6.composite_attribute_value = itme_Group.id //产品组合属性id
                                                        itme6.second_price = itme_Group.attribute_group_price
                                                      }
                                                    })
                                                  }
                                                  productFormula(obj).then((data)=>{
                                                    if (data.status){
                                                      itme6.result = data.info.result * itme6.second_price
                                                    }
                                                    else {
                                                      itme6.result = 1 * itme6.second_price
                                                    }
                                                    this.$set(this.productAccessories,index,itme)
                                                  })
                                                }
                                                else {
                                                  itme6.result = itme6.second_price
                                                }
                                              }
                                              else {
                                                // 循环第七级配件
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }
          },
          // 配件的数值范围限制
          onattributeSizerange(Identification,attribute_id,min,max){
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itmes)=>{
                // 判断是不是第一级配件
                if (Identification === itmes.Identification) {
                  itmes.productAttribute.map((itme)=>{
                    if (itme.attribute_id === attribute_id) {
                      if(min && itme.product_attribute_name < min){
                        this.$set(itme,'go_beyond',itmes.product_name + '的最小'+itme.product_attribute_name_title + '为' + min)
                      }
                      else if (max && itme.product_attribute_name > max) {
                        this.$set(itme,'go_beyond',itmes.product_name + '的最大'+itme.product_attribute_name_title + '为' + max)
                      }
                      else {
                        this.$set(itme,'go_beyond','')
                      }
                    }
                  })
                }
                else {
                  // 循环第二级配件
                  if (typeof itmes.partsInPartsData === 'object'){
                    itmes.partsInPartsData.map((itme2)=>{
                      // 判断是不是第二级配件
                      if (Identification === itme2.Identification) {
                        itme2.productAttribute.map((itme3)=>{
                          if (itme3.attribute_id === attribute_id) {
                            if(min && itme3.product_attribute_name < min){
                              this.$set(itme3,'go_beyond',itme2.product_name + '的最小'+itme3.product_attribute_name_title + '为' + min)
                            }
                            else if (max && itme3.product_attribute_name > max) {
                              this.$set(itme3,'go_beyond',itme2.product_name + '的最大'+itme3.product_attribute_name_title + '为' + max)
                            }
                            else {
                              this.$set(itme3,'go_beyond','')
                            }
                          }
                        })
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object'){
                          itme2.sub_level_data.map((itme3)=>{
                            // 判断是不是第三级配件
                            if (Identification === itme3.Identification) {
                              itme3.attribute_data.map((list)=>{
                                if (list.attribute_id === attribute_id) {
                                  if(min && list.product_attribute_name < min){
                                    this.$set(list,'go_beyond',itme3.name + '的最小'+list.product_attribute_name_title + '为' + min)
                                  }
                                  else if (max && list.product_attribute_name > max) {
                                    this.$set(list,'go_beyond',itme3.name + '的最大'+list.product_attribute_name_title + '为' + max)
                                  }
                                  else {
                                    this.$set(list,'go_beyond','')
                                  }
                                }
                              })
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object'){
                                itme3.sub_level_data.map((itme4)=>{
                                  // 判断是不是第四级配件
                                  if (Identification === itme4.Identification) {
                                    itme4.attribute_data.map((list)=>{
                                      if (list.attribute_id === attribute_id) {
                                        if(min && list.product_attribute_name < min){
                                          this.$set(list,'go_beyond',itme4.name + '的最小'+list.product_attribute_name_title + '为' + min)
                                        }
                                        else if (max && list.product_attribute_name > max) {
                                          this.$set(list,'go_beyond',itme4.name + '的最大'+list.product_attribute_name_title + '为' + max)
                                        }
                                        else {
                                          this.$set(list,'go_beyond','')
                                        }
                                      }
                                    })
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object'){
                                      itme4.sub_level_data.map((itme5)=>{
                                        // 判断是不是第五级配件
                                        if (Identification === itme5.Identification) {
                                          itme5.attribute_data.map((list)=>{
                                            if (list.attribute_id === attribute_id) {
                                              if(min && list.product_attribute_name < min){
                                                this.$set(list,'go_beyond',itme5.name + '的最小'+list.product_attribute_name_title + '为' + min)
                                              }
                                              else if (max && list.product_attribute_name > max) {
                                                this.$set(list,'go_beyond',itme5.name + '的最大'+list.product_attribute_name_title + '为' + max)
                                              }
                                              else {
                                                this.$set(list,'go_beyond','')
                                              }
                                            }
                                          })
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object'){
                                            itme5.sub_level_data.map((itme6)=>{
                                              // 判断是不是第六级配件
                                              if (Identification === itme6.Identification) {
                                                itme6.attribute_data.map((list)=>{
                                                  if (list.attribute_id === attribute_id) {
                                                    if(min && list.product_attribute_name < min){
                                                      this.$set(list,'go_beyond',itme6.name + '的最小'+list.product_attribute_name_title + '为' + min)
                                                    }
                                                    else if (max && list.product_attribute_name > max) {
                                                      this.$set(list,'go_beyond',itme6.name + '的最大'+list.product_attribute_name_title + '为' + max)
                                                    }
                                                    else {
                                                      this.$set(list,'go_beyond','')
                                                    }
                                                  }
                                                })
                                              }
                                              else {
                                                // 循环第七级配件
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }
          },

          //电脑设备事件
          mouseDown(ev) {
            if (this.editing_status !== 'painting') {
              return
            }
            ev = ev || event
            ev.preventDefault()
            if (1) {
              let obj = {
                x: ev.offsetX,
                y: ev.offsetY
              }
              this.startX = obj.x
              this.startY = obj.y
              this.canvasTxt.beginPath()
              this.canvasTxt.lineWidth = "2";
              this.canvasTxt.strokeStyle = "#000";
              this.canvasTxt.moveTo(this.startX, this.startY)
              this.canvasTxt.lineTo(obj.x, obj.y)
              this.canvasTxt.stroke()
              this.canvasTxt.closePath()
              this.points.push(obj)
              this.isDown = true
              this.imgUrl = (this.$refs.canvasF && this.$refs.canvasF.toDataURL()) || ''
            }
          },
          mouseMove(ev) {
            if (this.editing_status !== 'painting') {
              return
            }
            ev = ev || event
            ev.preventDefault()
            if (this.isDown) {
              let obj = {
                x: ev.offsetX,
                y: ev.offsetY
              }
              this.moveY = obj.y
              this.moveX = obj.x
              this.canvasTxt.beginPath()
              this.canvasTxt.lineWidth = "2";
              this.canvasTxt.strokeStyle = "#000";
              this.canvasTxt.moveTo(this.startX, this.startY)
              this.canvasTxt.lineTo(obj.x, obj.y)
              this.canvasTxt.stroke()
              this.canvasTxt.closePath()
              this.startY = obj.y
              this.startX = obj.x
              this.points.push(obj)
            }
          },
          mouseUp(ev) {
            if (this.editing_status !== 'painting') {
              return
            }
            ev = ev || event
            ev.preventDefault()
            if (1) {
              let obj = {
                x: ev.offsetX,
                y: ev.offsetY
              }
              this.canvasTxt.beginPath()
              this.canvasTxt.lineWidth = "2";
              this.canvasTxt.strokeStyle = "#000";
              this.canvasTxt.moveTo(this.startX, this.startY)
              this.canvasTxt.lineTo(obj.x, obj.y)
              this.canvasTxt.stroke()
              this.canvasTxt.closePath()
              this.points.push(obj)
              this.points.push({x: -1, y: -1})
              this.isDown = false
            }
          },
          //移动设备事件
          touchStart(ev) {
            if (this.editing_status !== 'painting') {
              return
            }
            ev = ev || event
            ev.preventDefault()
            if (ev.touches.length == 1) {
              let obj = {
                x: ev.targetTouches[0].clientX - 10,
                y: ev.targetTouches[0].clientY - 65
              }
              this.startX = obj.x
              this.startY = obj.y
              this.canvasTxt.beginPath()
              this.canvasTxt.lineWidth = "2";
              this.canvasTxt.strokeStyle = "#000";
              this.canvasTxt.moveTo(this.startX, this.startY)
              this.canvasTxt.lineTo(obj.x, obj.y)
              this.canvasTxt.stroke()
              this.canvasTxt.closePath()
              this.points.push(obj)
            }
          },
          touchMove(ev) {
            if (this.editing_status !== 'painting') {
              return
            }
            ev = ev || event
            ev.preventDefault()
            if (ev.touches.length == 1) {
              let obj = {
                x: ev.targetTouches[0].clientX - 10,
                y: ev.targetTouches[0].clientY - 65
              }
              this.moveY = obj.y
              this.moveX = obj.x
              this.canvasTxt.beginPath()
              this.canvasTxt.lineWidth = "2";
              this.canvasTxt.strokeStyle = "#000";
              this.canvasTxt.moveTo(this.startX, this.startY)
              this.canvasTxt.lineTo(obj.x, obj.y)
              this.canvasTxt.stroke()
              this.canvasTxt.closePath()
              this.startY = obj.y
              this.startX = obj.x
              this.points.push(obj)
            }
          },
          touchEnd(ev) {
            if (this.editing_status !== 'painting') {
              return
            }
            ev = ev || event
            ev.preventDefault()
            if (ev.touches.length == 1) {
              let obj = {
                x: ev.targetTouches[0].clientX - 10,
                y: ev.targetTouches[0].clientY - 65
              }
              this.canvasTxt.beginPath()
              this.canvasTxt.lineWidth = "2";
              this.canvasTxt.strokeStyle = "#000";
              this.canvasTxt.moveTo(this.startX, this.startY)
              this.canvasTxt.lineTo(obj.x, obj.y)
              this.canvasTxt.stroke()
              this.canvasTxt.closePath()
              this.points.push(obj)
              this.points.push({x: -1, y: -1})
              this.imgUrl =
                (this.$refs.canvasF && this.$refs.canvasF.toDataURL()) || ''
            }
          },
          //重写
          overwrite() {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '重写将会清除您之前的操作，您确定重写么?',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: true
              }).then((v) => {
                if (v === 'confirm') {
                  this.canvasTxt.clearRect(
                    0,
                    0,
                    this.$refs.canvasF.width,
                    this.$refs.canvasF.height
                  )
                  this.points = []
                  this.canvasTxt.drawImage(this.original_graph, 0, 0)
                }
                else {
                }
              });
            }
            else {
              this.$confirm('重写将会清除您之前的操作，您确定重写么?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                distinguishCancelAndClose: true,
                type: 'warning'
              }).then(() => {
                this.canvasTxt.clearRect(
                  0,
                  0,
                  this.$refs.canvasF.width,
                  this.$refs.canvasF.height
                )
                this.points = []
                this.canvasTxt.drawImage(this.original_graph, 0, 0)
              }).catch((c) => {
              });
            }
          },
          click_canvas(e) {
            if (this.editing_status === 'input_text') {
              this.inputX = e.offsetX
              this.inputY = e.offsetY - 8
              this.$refs.canvas_input.style.left = this.inputX + 'px'
              this.$refs.canvas_input.style.top = this.inputY + 'px'
              this.$refs.canvas_input.focus()
            }
          },
          input_text() {
            this.$refs.canvasF.style.cursor = 'text';
            this.editing_status = 'input_text'
          },
          input_text_en() {
            this.$refs.canvasF.style.cursor = 'auto';
            this.editing_status = ''
            this.text_in_canvas()
          },
          text_in_canvas() {
            this.canvasTxt.font = "16px 黑体";
            // 设置颜色
            this.canvasTxt.fillStyle = "#000";
            // 设置水平对齐方式
            this.canvasTxt.textAlign = "center";
            // 设置垂直对齐方式
            this.canvasTxt.textBaseline = "middle";
            // 绘制文字（参数：要写的字，x坐标，y坐标）
            this.canvasTxt.fillText(this.canvas_text, this.inputX + 15, this.inputY + 8);
            this.canvas_text = ''
          },
          painting() {
            this.$refs.canvasF.style.cursor = 'auto';
            this.editing_status = 'painting'
          },
          //提交签名
          commit() {
            console.log(this.$refs.canvasF.toDataURL())
          },

          //加入购物车
          onmessagebox(copy){
            //自動保存編輯的文字
            if (this.editing_status === 'input_text'){
              this.input_text_en()
            }
            // 储存Canvas图片
            this.detail.canvas_img_data = this.$refs.canvasF.toDataURL("image/png")
            this.detail.formula_handle = []
            this.detail.attributeData  = []
            this.detail.partsData = []
            this.detail.remarks = this.remarks
            this.detail.installation = localStorage.getItem('installation')
            this.detail.warehouse_name = localStorage.getItem('Installationlocation')
            this.detail.unit_price = this.total

            let attribute = false //产品和配件属性不能为空
            let go_beyond = false //是否有产品属性或配件属性超出最大值
            this.productAttribute.map((itme)=>{
              // 判断是否有属性超出了最大值或小于最小值
              if (itme.go_beyond && itme.go_beyond !==''){
                go_beyond = itme.go_beyond
              }
              // 判断是否有未选择的属性
              if (Number(itme.required) && (itme.product_attribute_name === '' || (Array.isArray(itme.product_attribute_name) && itme.product_attribute_name.length === 0))){
                // attribute = this.detail.product_name + ' 的 '+ itme.product_attribute_name_title +' 属性必須填寫或選擇'
                attribute = `The ${itme.product_attribute_name_title} property of ${this.detail.product_name} must be filled in or selected`
              }
              this.detail.formula_handle.push([itme.product_attribute_name_title]+':'+itme.product_attribute_name.toString().replace(/\,/g,"，"))
              this.detail.attributeData.push({
                attribute_id:itme.attribute_id,
                attribute_value:itme.product_attribute_name,
                type:itme.attribute_list?1:0,
              })
            })
            //如果属性为空，传空字符
            if (this.detail.formula_handle.length===0){
              this.detail.formula_handle = ''
            }
            // console.log(this.detail)
            if(typeof this.productAccessories === 'object'){
              this.productAccessories.map((productAccessories_itme)=>{
                if (typeof productAccessories_itme.productAccessories === 'object') {
                  productAccessories_itme.productAccessories.map(itme=>{
                    //获取选中的配件 数量大于0
                    if (itme.sun > 0) {

                      let partsInPartsData = []
                      if (typeof itme.partsInPartsData  === 'object') {
                        itme.partsInPartsData.map((list)=>{
                          //获取被选中的子配件  数量大于0
                          if (list.sun > 0) {
                            //三级配件
                            let childpartsInPartsData = []
                            if (typeof list.sub_level_data  === 'object') {
                              list.sub_level_data.map((childlist)=>{
                                //获取被选中的三级配件  数量大于0
                                if (childlist.sun > 0) {

                                  let childpartsInPartsData4 = []
                                  if (typeof childlist.sub_level_data  === 'object') {
                                    childlist.sub_level_data.map((childlist4)=>{
                                      //获取被选中的第三级配件  数量大于0
                                      if (childlist4.sun > 0) {
                                        // 五级配件
                                        let childpartsInPartsData5 = []
                                        if (typeof childlist4.sub_level_data  === 'object') {
                                          childlist4.sub_level_data.map((childlist6)=>{
                                            //获取被选中的第四级配件  数量大于0
                                            if (childlist6.sun > 0) {
                                              let childpartsInPartsData6 = []
                                              if (typeof childlist6.sub_level_data  === 'object') {
                                                childlist6.sub_level_data.map((childlist7)=>{
                                                  //获取被选中的第四级配件  数量大于0
                                                  if (childlist7.sun > 0) {
                                                    //获取三级配件选中的属性
                                                    let childformula_handle = []
                                                    let attributeData = []
                                                    if(typeof childlist7.attribute_data === 'object'){
                                                      childlist7.attribute_data.map((list2)=>{
                                                        // 判断是否有属性超出了最大值或小于最小值
                                                        if (list2.go_beyond && list2.go_beyond !==''){
                                                          go_beyond = list2.go_beyond
                                                        }
                                                        // 判断是否有未选择的属性
                                                        if (Number(list2.required) && (list2.product_attribute_name === '' || (Array.isArray(list2.product_attribute_name) && list2.product_attribute_name.length === 0))){
                                                          attribute = `The ${list2.product_attribute_name_title} property of ${childlist7.name} must be filled in or selected`
                                                        }
                                                        childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                                        attributeData.push({
                                                          attribute_id:list2.attribute_id,
                                                          attribute_value:list2.product_attribute_name,
                                                          type:list2.attribute_list?1:0,
                                                        })
                                                      })
                                                    }
                                                    //六级级配件
                                                    childpartsInPartsData6.push({
                                                      'product_id':childlist7.self_id,
                                                      'attribute_group_id':childlist7.composite_attribute_value,
                                                      'attribute_group_price':childlist7.second_price,
                                                      'parts_name':childlist7.name,
                                                      'product_description':childlist7.description,
                                                      'product_description_en':childlist7.product_description_en,
                                                      'product_model':childlist7.model,
                                                      'product_installation_charge':childlist7.installation_charge,
                                                      'product_formula_id':childlist7.product_formula_id,
                                                      'totalquantity':childlist7.sun,
                                                      'parts_formula_result_value':childlist7.result,
                                                      'currency_symbol':childlist7.installation_charge_currency_symbol,
                                                      'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                                      'attributeData':attributeData,
                                                      'productid':this.detail.product_id,
                                                    })
                                                  }
                                                })
                                              }
                                              //获取五级配件选中的属性
                                              let childformula_handle = []
                                              let attributeData = []
                                              if(typeof childlist6.attribute_data === 'object'){
                                                childlist6.attribute_data.map((list2)=>{
                                                  // 判断是否有属性超出了最大值或小于最小值
                                                  if (list2.go_beyond && list2.go_beyond !==''){
                                                    go_beyond = list2.go_beyond
                                                  }
                                                  // 判断是否有未选择的属性
                                                  if (Number(list2.required) && (list2.product_attribute_name === '' || (Array.isArray(list2.product_attribute_name) && list2.product_attribute_name.length === 0))){
                                                    attribute = `The ${list2.product_attribute_name_title} property of ${childlist6.name} must be filled in or selected`
                                                  }
                                                  childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                                  attributeData.push({
                                                    attribute_id:list2.attribute_id,
                                                    attribute_value:list2.product_attribute_name,
                                                    type:list2.attribute_list?1:0,
                                                  })
                                                })
                                              }
                                              //五级级配件
                                              childpartsInPartsData5.push({
                                                'product_id':childlist6.self_id,
                                                'attribute_group_id':childlist6.composite_attribute_value,
                                                'attribute_group_price':childlist6.second_price,
                                                'parts_name':childlist6.name,
                                                'product_description':childlist6.description,
                                                'product_description_en':childlist6.product_description_en,
                                                'product_model':childlist6.model,
                                                'product_installation_charge':childlist6.installation_charge,
                                                'product_formula_id':childlist6.product_formula_id,
                                                'totalquantity':childlist6.sun,
                                                'parts_formula_result_value':childlist6.result,
                                                'currency_symbol':childlist6.installation_charge_currency_symbol,
                                                'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                                'attributeData':attributeData,
                                                'partsInPartsData':childpartsInPartsData6,
                                                'productid':this.detail.product_id,
                                              })
                                            }
                                          })
                                        }
                                        //获取四级配件选中的属性
                                        let childformula_handle = []
                                        let attributeData = []
                                        if(typeof childlist4.attribute_data === 'object'){
                                          childlist4.attribute_data.map((list2)=>{
                                            // 判断是否有属性超出了最大值或小于最小值
                                            if (list2.go_beyond && list2.go_beyond !==''){
                                              go_beyond = list2.go_beyond
                                            }
                                            // 判断是否有未选择的属性
                                            if (Number(list2.required) && (list2.product_attribute_name === '' || (Array.isArray(list2.product_attribute_name) && list2.product_attribute_name.length === 0))){
                                              attribute = `The ${list2.product_attribute_name_title} property of ${childlist4.name} must be filled in or selected`
                                            }
                                            childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                            attributeData.push({
                                              attribute_id:list2.attribute_id,
                                              attribute_value:list2.product_attribute_name,
                                              type:list2.attribute_list?1:0,
                                            })
                                          })
                                        }
                                        //四级级配件
                                        childpartsInPartsData4.push({
                                          'product_id':childlist4.self_id,
                                          'attribute_group_id':childlist4.composite_attribute_value,
                                          'attribute_group_price':childlist4.second_price,
                                          'parts_name':childlist4.name,
                                          'product_description':childlist4.description,
                                          'product_description_en':childlist4.product_description_en,
                                          'product_model':childlist4.model,
                                          'product_installation_charge':childlist4.installation_charge,
                                          'product_formula_id':childlist4.product_formula_id,
                                          'totalquantity':childlist4.sun,
                                          'parts_formula_result_value':childlist4.result,
                                          'currency_symbol':childlist4.installation_charge_currency_symbol,
                                          'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                          'attributeData':attributeData,
                                          'partsInPartsData':childpartsInPartsData5,
                                          'productid':this.detail.product_id,
                                        })
                                      }
                                    })
                                  }

                                  //获取子配件的子配件选中的属性
                                  let childformula_handle = []
                                  let attributeData = []
                                  if(typeof childlist.attribute_data === 'object'){
                                    childlist.attribute_data.map((list2)=>{
                                      // 判断是否有属性超出了最大值或小于最小值
                                      if (list2.go_beyond && list2.go_beyond !==''){
                                        go_beyond = list2.go_beyond
                                      }
                                      // 判断是否有未选择的属性
                                      if (Number(list2.required) && (list2.product_attribute_name === '' || (Array.isArray(list2.product_attribute_name) && list2.product_attribute_name.length === 0))){
                                        attribute = `The ${list2.product_attribute_name_title} property of ${childlist.name} must be filled in or selected`
                                      }
                                      childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                      attributeData.push({
                                        attribute_id:list2.attribute_id,
                                        attribute_value:list2.product_attribute_name,
                                        type:list2.attribute_list?1:0,
                                      })
                                    })
                                  }
                                  //三级级配件
                                  childpartsInPartsData.push({
                                    'product_id':childlist.self_id,
                                    'attribute_group_id':childlist.composite_attribute_value,
                                    'attribute_group_price':childlist.second_price,
                                    'parts_name':childlist.name,
                                    'product_description':childlist.description,
                                    'product_description_en':childlist.product_description_en,
                                    'product_model':childlist.model,
                                    'product_installation_charge':childlist.installation_charge,
                                    'product_formula_id':childlist.product_formula_id,
                                    'totalquantity':childlist.sun,
                                    'parts_formula_result_value':childlist.result,
                                    'currency_symbol':childlist.installation_charge_currency_symbol,
                                    'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                    'attributeData':attributeData,
                                    'partsInPartsData':childpartsInPartsData4,
                                    'productid':this.detail.product_id,
                                  })
                                }
                              })
                            }
                            //获取子配件选中的属性
                            let childformula_handle = []
                            let attributeData = []

                            if(typeof list.productAttribute === 'object'){
                              list.productAttribute.map((list2)=>{
                                // 判断是否有属性超出了最大值或小于最小值
                                if (list2.go_beyond && list2.go_beyond !==''){
                                  go_beyond = list2.go_beyond
                                }
                                // 判断是否有未选择的属性
                                if (Number(list2.required) && (list2.product_attribute_name === '' || (Array.isArray(list2.product_attribute_name) && list2.product_attribute_name.length === 0))){
                                  attribute = `The ${list2.product_attribute_name_title} property of ${list.name} must be filled in or selected`
                                }
                                childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                attributeData.push({
                                  attribute_id:list2.attribute_id,
                                  attribute_value:list2.product_attribute_name,
                                  type:list2.attribute_list?1:0,
                                })
                              })
                            }
                            //二级配件
                            partsInPartsData.push({
                              'product_id':list.product_id,
                              'attribute_group_id':list.composite_attribute_value,
                              'attribute_group_price':list.productAccessoriesPrice,
                              'parts_name':list.product_name,
                              'product_description':list.product_description,
                              'product_description_en':list.product_description_en,
                              'product_model':list.product_model,
                              'product_installation_charge':list.product_installation_charge,
                              'product_formula_id':list.product_formula_id,
                              'totalquantity':list.sun,
                              'parts_formula_result_value':list.result,
                              'currency_symbol':list.currency_symbol,
                              'formula_handle':childformula_handle.length>0?childformula_handle:'',
                              'attributeData':attributeData,
                              'partsInPartsData':childpartsInPartsData,
                              'productid':this.detail.product_id,
                            })

                          }
                        })
                      }
                      let formula_handle = []
                      let attributeData = []
                      //被选中的配件属性
                      if(typeof itme.productAttribute === 'object'){
                        itme.productAttribute.map((list)=>{
                          // 判断是否有属性超出了最大值或小于最小值
                          if (list.go_beyond && list.go_beyond !==''){
                            go_beyond = list.go_beyond
                          }
                          // 判断是否有未选择的属性
                          if (Number(list.required) && (list.product_attribute_name === '' || (Array.isArray(list.product_attribute_name) && list.product_attribute_name.length === 0))){
                            attribute = `The ${list.product_attribute_name_title} property of ${itme.name} must be filled in or selected`
                          }
                          formula_handle.push([list.product_attribute_name_title]+':'+list.product_attribute_name.toString().replace(/\,/g,"，"))
                          attributeData.push({
                            attribute_id:list.attribute_id,
                            attribute_value:list.product_attribute_name,
                            type:list.attribute_list?1:0,
                          })
                        })
                      }
                      itme.expend_price=itme.productAccessoriesPrice
                      itme.Parentid=this.detail.product_id
                      //一级配件
                      this.detail.partsData.push({
                        'product_id':itme.product_id,
                        'attribute_group_id':itme.composite_attribute_value,
                        'attribute_group_price':itme.productAccessoriesPrice,
                        'parts_name':itme.product_name,
                        'product_description':itme.product_description,
                        'product_description_en':itme.product_description_en,
                        'product_installation_charge':itme.product_installation_charge,
                        'product_formula_id':itme.product_formula_id,
                        'totalquantity':itme.sun,
                        'parts_formula_result_value':itme.result,
                        'formula_handle':formula_handle.length>0?formula_handle:'',
                        'attributeData':attributeData,
                        'currency_symbol':itme.currency_symbol,
                        'partsInPartsData':partsInPartsData,
                        'productid':this.detail.product_id,
                        'bigImageUrl': itme.bigImageUrl,
                      })
                      // LocalShoppingCart(itme.product_id,itme.sun,itme.product_id,itme)
                    }
                  })
                }
              })
            }
            // 超出尺寸时的提示框
            if(go_beyond){
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  message: go_beyond,
                }).then(()=>{
                });
              }
              else {
                this.$alert(go_beyond, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
              return;
            }
            // 属性未选择时的提示框
            if(attribute){
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  message: attribute,
                }).then(()=>{
                });
              }
              else {
                this.$alert(attribute, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
              return;
            }
            if (copy === 1){
              LocalShoppingCart(this.detail.product_id,this.num,this.detail.expend_id,this.detail)
            }
            else {
              LocalShoppingCart(this.detail.product_id,this.num,this.detail.expend_id,this.detail,this.$route.query.index)
            }
            if (this.$store.state.client){
              MessageBox({
                title: '提示',
                message: '操作成功',
              }).then(()=>{
                this.$router.go(-1)
              });
            }
            else {
              this.$alert('操作成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.go(-1)
                }
              });
            }
          },
        },
        computed:{
          total(){
            let totalall = 0
            let a = this.productAccessories
            for(let i=0;i<a.length;i++){
              if (a[i].sun > 0) {
                //计算选中的配件价格
                totalall += (a[i].sun * a[i].result) + ( a[i].sun*a[i].product_installation_charge)
                if (typeof a[i].partsInPartsData === 'object'){
                  a[i].partsInPartsData.map((itme)=>{
                    if (itme.sun > 0){
                      //计算选中的子配件价格
                      // console.log(itme.result)
                      totalall += (itme.sun * itme.result) + ( itme.sun*itme.product_installation_charge)
                      if (typeof itme.sub_level_data === 'object'){
                        itme.sub_level_data.map((itme3)=>{
                          if (itme3.sun > 0){
                            //计算选中的第三级配件价格
                            totalall += (itme3.sun * itme3.result) + ( itme3.sun*itme3.installation_charge)
                            if (typeof itme3.sub_level_data === 'object'){
                              itme3.sub_level_data.map((itme4)=>{
                                if (itme4.sun > 0){
                                  //计算选中的第四级配件价格
                                  totalall += (itme4.sun * itme4.result) + ( itme4.sun*itme4.installation_charge)
                                  if (typeof itme4.sub_level_data === 'object'){
                                    itme4.sub_level_data.map((itme5)=>{
                                      if (itme5.sun > 0){
                                        //计算选中的第五级配件价格
                                        totalall += (itme5.sun * itme5.result) + ( itme5.sun*itme5.installation_charge)
                                        if (typeof itme5.sub_level_data === 'object'){
                                          itme5.sub_level_data.map((itme6)=>{
                                            if (itme6.sun > 0){
                                              //计算选中的第六级配件价格
                                              totalall += (itme6.sun * itme6.result) + ( itme6.sun*itme6.installation_charge)
                                            }
                                          })
                                        }
                                      }
                                    })
                                  }
                                }
                              })
                            }
                          }
                        })
                      }
                    }
                  })
                }
              }
            }
            totalall += (this.detail.result*this.num) + (this.num*this.detail.product_installation_charge)
            return totalall.toFixed(2)
          },
        }
    }
</script>

<style lang="less">
  @import "../assets/less/base";
  .popper-class.el-select{
    color: transparent;
    width: 28px !important;
    min-height: 28px;
    border-radius: 50%;
    margin-bottom: 0;
    margin-left: 0;
    .el-select-dropdown{
      background-color: transparent !important;
    }
    >.el-input{
      margin-bottom: 0 !important;
      width: auto;
      margin-left: 0;
      input{
        background: transparent;
        color: transparent;
        width: 28px !important;
        height: 28px;
        border-radius: 50%;
        padding: 0;
        border: none;
      }
      .el-input__suffix{
        display: none;
      }
    }
    .el-input__inner{
      /*border: none;*/
    }
  }

  .selectitme{
    color: transparent !important;
    border-radius: 50%;
    padding: 0 !important;
    margin-top: 5px;
    width: 34px;
    &.el-select-dropdown__item.hover{
      background-color: transparent;
    }
    &.el-select-dropdown__item.selected{
      color: transparent;
    }
  }



  .contentbox.productedit{
    background-color: #f2f2f2;
    width: 100%;

    .toptitle{
      position: fixed;
      z-index: 2;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      /*position: relative;*/
      display: flex;
      justify-content: space-between;
      width: 90%;
      padding: 0 5%;
      img{
        height: 46px;
      }
      .personalicon{
        img{
          height: 32px;
          margin-left: 10px;
        }
      }
      .return{
        font-size: 40px;
        position: initial;
        cursor: pointer;
      }
      >div{
        span{
          display: inline-block;
          cursor: pointer;
        }
      }
    }
    .PersonalCenter{
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      text-align: center;
      h1{
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div{
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .pcbox{
      margin-top: 50px;
      @media (min-width: @screen-xs-max) {
        display: flex;
        justify-content: space-around;
        background-color: #fff;
        padding: 2%;
      }
      .topimgbox {
        min-height: 300px;
        .canvasBox {
          position: relative;
          canvas {
            border: 1px solid #5a5a5a;
          }
          textarea {
            position: absolute;
            background: transparent;
            /*border-bottom: 1px;*/
          }
          .btnBox{
            margin-top: 20px;
          }
        }
        @media (min-width: @screen-xs-max) {
          width: 46%;
        }
        img {
          width: 50%;
          display: none;
        }
      }
      .r{
        @media (min-width: @screen-xs-max) {
          width: 46%;
        }
        .numberbox{
          background-color: #fff;
          font-size: 16px;
          padding: 0.2rem;
          div{
            margin-bottom: 0.2rem;
            .attributename{
              width: 40%;
              display: inline-block;
            }
            .el-select{
              width: 56%;
              min-height: 28px;
              line-height: 28px;
              .el-select__tags{
                padding-bottom: 10px;
              }
            }
          }
          .number{
            .lf{
              .reduce,.add{
                display: inline-block;
                border-radius: 50%;
                border: 1px solid #000;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
              }
              .num{
                margin: 0 0.2rem;
              }
            }
            .rg{
              color: #666;
            }
          }
        }
        .computedbox{
          /*display: flex;*/
          /*justify-content: space-between;*/
          /*align-items: center;*/
          background: #fff;
          margin-top: 0.2rem;
          padding: 0.2rem;
          height: 10px;
          overflow: hidden;
          @media (min-width: @screen-xs-max) {
            height: auto;
          }
          .clickbox{
            cursor: pointer;
          }
          >div{
            margin-bottom: 0.2rem;
            display: flex;
            align-items: center;
            /*justify-content: space-between;*/
            .attributename{
              width: 40%;
              display: inline-block;
            }
            .el-input{
              width: 20%;
              input::-webkit-outer-spin-button,
              input::-webkit-inner-spin-button { -webkit-appearance: none; }
              input[type="number"]{ -moz-appearance: textfield; }
            }
            .el-select{
              .el-input{
                width: 96%;
              }
            }
            p{
              width: 20%;
            }
          }
        }
      }
    }

    .meassagebox{
      margin-top: 0.2rem;
      background-color: #fff;
      padding: 0.2rem;
      display: flex;
    }
    .garnishbox{
      background-color: #fff;
      margin-top: 0.2rem;
      padding: 0 0.1rem 0.1rem 0.1rem;
      h1{
        font-size: 16px;
        padding: 0.2rem;
      }
      ul{
        width: 100%;
        overflow-x: auto;
        /*overflow-y: hidden;*/
        white-space: nowrap;
        /*display: flex;*/
        /*justify-content: flex-start;*/
        li{
          /*height: 56px;*/
          vertical-align: text-top;
          overflow: hidden;
          width:48%;
          display: inline-block;
          margin: 0.1rem 0.1rem;
          @media (min-width: @screen-xs-max) {
            width:30%;
          }
          @media (min-width: 1000px) {
            width: 6% !important;
          }
          .titlebox{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            /*align-items: center;*/
            padding: 10px;
            background-color: #f7f7f7;
            min-height: 60px;
            white-space: pre-wrap;
            p{
              /*width: 20%;*/
            }
            p.tltle{
              /*width: 46%;*/
              display: flex !important;
              justify-content: space-between;
              i{
                font-size: 16px;
                color: #67C23A;
                font-weight: bold;
              }
            }
            p.selectedquantity{
              display: flex;
              justify-content: space-between;
            }
            .t {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              white-space: pre-wrap;
              p.tltle {
                /*width: 46%;*/
                display: flex;
                justify-content: space-between;
              }
              p.selectedquantity {
                display: flex;
                justify-content: space-between;
              }
            }
            .img_box {
              width: 100%;
            }
          }
          .attributebox{
            display: flex;
            align-items: center;
            transition: all .5s;
            background-color: #f7f7f7;
            padding:0 10px;
            /*border-bottom: 1px solid #706c6c;*/
            /*width: 96vw;*/
            &.give{
              padding-bottom: 10px;
            }
            .name{
              margin-bottom: 0.2rem;
            }
            >div{
              /*margin-left: 10px;*/
              min-width: 36px;
            }
          }
          .garden{
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #979797;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: #fff;
            color: #fff;
          }
          .garden.active{
            background-color: @maincolor2;
            color: #5a5a5a;
          }
          img{
            width: 100%;
            cursor: pointer;
          }
          .type_box{
            background-color: #f7f7f7;
            padding: 10px 0;
            img{
              display: block;
              width: 80%;
              margin: 0 auto;
              cursor: auto;
            }
          }
          p{
            display: block !important;
            /*justify-content: space-between;*/
            margin-bottom: 0.2rem;
            align-items: center;
            white-space: initial;
            &.one{
              padding-top: 0.2rem;
              border-top: 1px solid #706c6c;
            }
            &.towbottom{
              padding-bottom: 0.2rem;
              border-bottom: 1px solid #706c6c;
            }
            div{
              /*width: 70%;*/
              /*margin-left: 0.2rem;*/
              input::-webkit-outer-spin-button,
              input::-webkit-inner-spin-button { -webkit-appearance: none; }
              input[type="number"]{ -moz-appearance: textfield; }
            }
            .el-select{
              width: 100%;
              .el-input{
                width: 100%;
              }
            }
            span{
              /*width: 60%;*/
              display: inline-block;
              &.formula{
                width: 20%;
              }
              &.formula2{
                width: 22%;
              }
            }
            .reduce,.add{
              display: inline-block;
              /*border-radius: 50%;*/
              /*border: 1px solid #000;*/
              font-weight: bold;
              color: #fff;
              text-align: center;
              line-height: 24px;
              font-size: 24px;
              cursor: pointer;
              width: 38px;
            }
            span.num{
              /*margin: 0 0.01rem;*/
              font-weight: bold;
              color: #fff;
              width: 34%;
              line-height: 20px;
              text-align: center;
            }
          }
          .tltle{
            display: block;
            /*margin-top: 10px;*/
          }
          .sunbox{
            align-items: center;
            justify-content: space-around;
            background-color: #000;
            height: 30px;
          }
          &.active{
            height: 100%;
          }
        }
      }
      ul.childPartsData{
        flex-direction: column;
        li{
          /*height: 56px;*/
          margin: 0.1rem 0.1rem;
          /*overflow: hidden;*/
          &.active{
            height: 100%;
          }
        }
        .titlebox{
          min-height: 60px;
          white-space: pre-wrap;
          p{
            /*width: 24%;*/
            /*text-align: right;*/
          }
          .tltle{
            /*width: 48%;*/
          }
          .productAccessoriesPrice{
            /*width: 20%;*/
            /*padding-left: 4%;*/
          }
          .productAccessoriesPrice3{
            /*width: 24%;*/
          }
        }

      }
      .onproductAccessories{
        padding: 0.2rem;
      }
    }
    .costbox{
      padding: 0.2rem;
      margin-top: 0.2rem;
      background-color: #fff;
      ul{
        li{
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          margin-top: 0.2rem;
        }
        .red{
          color: #e4e7ed;
        }
        .gray{
          color: #a6a6a6;
        }
      }
    }
    .pcbox2{
      background-color: #fff;
      @media (min-width: @screen-xs-max) {
        display: flex;
        justify-content: space-between;
        padding: 0 2% 50px 2%;
        margin-top: 0.2rem;
        >div{
          width: 46%;
        }
      }
      .l{
        .totalbox{
          margin-top: 0.2rem;
          padding: 0.5rem 0.2rem 0.2rem;
          background-color: #fff;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
        }
        .remarks{
          padding: 0.2rem;
          background-color: #fff;
          textarea{
            width: 100%;
            min-height: 200px;
            border: 1px solid #5a5a5a;
            padding: 10px;
          }
        }
      }
      .r{
        .usermeassagebox{
          display: flex;
          justify-content: center;
          margin-top: 0.2rem;
          padding: 0.5rem 0.2rem 0.2rem;
          ul{
            width: 40%;
            padding-top: 0.2rem;
            background-color: #fff;
            li{
              display: flex;
              /*justify-content: space-between;*/
              align-items: center;
              /*border-bottom: 1px solid #e8e8e8;*/
              padding: 0.2rem;
              input{
                width: 100%;
              }
              span{
                display: flex;
                justify-content: space-between;
                align-items: center;
                span{
                  font-size: 26px;
                  margin-left: 0.1rem;
                }
              }
              textarea{
                height: 40px;
                width: 100%;
                resize: none;
                &::placeholder{
                  color: #333;
                }
              }
            }
          }
          >div{
            width: 58%;
            padding-right: 2%;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img{
              max-width: 100%;
            }
          }
        }
        .butbox{
          background: @maincolor2;
          float: left;
          width: 44%;
          color: #fff;
          padding: 0.3rem 0.2rem;
          font-size: 18px;
          text-align: center;
          cursor: pointer;
        }
        .buboxadd{
          background: #535353;
        }
      }
    }

    .modebox{
      padding: 0.2rem;
      background-color: #f2f2f2;
      font-size: 16px;
      border-bottom: 1px solid #979797;
      border-top: 1px solid #979797;
      ul{
        display: flex;
        justify-content: space-between;
        li{
          .garden{
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #979797;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: #fff;
            color: transparent;
          }
        }
        .active{
          .garden{
            background: @maincolor2;
          }
        }
      }
    }
    .footerbox{
      padding: 0.3rem 0.2rem;
      background-color: #f7f7f7;
      font-size: 18px;
      color: #a6a6a6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productedit.vue